<template>
  <div class="va-row">
    <div class="flex md12 xs12">
      <vuestic-widget>
        <div class="va-row">
          <div class="flex md4">
            <div class="select-title">{{'t.app' | translate}}</div>
            <el-select v-model="waybillListParams.app_id" :placeholder="$t('basic.select.all')" filterable>
              <el-option v-for="item in appList" :key="item.id" :value="item.id" :label="item.name"/>
            </el-select>
          </div>
          <div class="flex md4">
            <div class="select-title">{{'t.waybillStatus' | translate}}</div>
            <el-select v-model="waybillListParams.review_status" :placeholder="$t('menu.wayBill')">
              <el-option v-for="(item, index) in waybillStatus" :value="item.value" :label="item.label" :key="index"></el-option>
            </el-select>
          </div>
          <div class="flex md4">
            <div class="va-row">
              <div class="flex md6">
                <div class="select-title" style="white">{{'t.carrierRegion' | translate}}</div>
                <el-select
                v-model="carrierRegion"
                filterable
                @change="carrierRegionChange"
                >
                <el-option
                  v-for="(item, index) in carriersRegion"
                  :key="index"
                  :label="item.value"
                  :value="item.value"
                />
                </el-select>
              </div>
              <div class="flex md6">
                <div class="select-title">{{'t.carrier' | translate}}</div>
                <el-select v-model="waybillListParams.carrier_code" filterable :placeholder="$t('t.carrier')">
                  <el-option
                    v-for="item in filterCarriers"
                    :key="item.code"
                    :label="item.code"
                    :value="item.code">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>

        <div class="va-row">
          <div class="flex md4">
            <div class="select-title">{{'t.dateMode' | translate}}</div>
            <el-select v-model="waybillListParams.date_mode" :placeholder="$t('t.dateMode')" @change="dateModeChange">
              <el-option v-for="(item, index) in dateModeOptions" :label="item.label" :value="item.value" :key="index"/>
            </el-select>
          </div>
          <div class="flex md4">
            <div class="select-title">{{'t.timeZone' | translate}}</div>
            <el-select v-model="waybillListParams.zone_id" :disabled="isTimeZoned">
              <el-option v-for="(item, index) in timeZoneOptions" :label="item.label" :value="item.value" :key="index"/>
            </el-select>
          </div>
          <div class="flex md4">
            <div class="select-title">{{'t.dateRange' | translate}}</div>
            <el-date-picker
              :disabled="isTimeZoned"
              v-model="waybillListParams.time"
              style="width: 100% !important"
              type="daterange"
              :picker-options="pickerOptions"
              unlink-panels
              range-separator="-"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              @focus="limitNextDay"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="start"
              end-placeholder="end"
            >
            </el-date-picker>
          </div>
        </div>

        <div class="va-row">
          <div class="flex md4">
            <div class="select-title">{{'t.trackingStatus' | translate}}</div>
            <el-select v-model="waybillListParams.tracking_status" :placeholder="$t('t.trackingStatus')">
              <el-option v-for="(item, index) in trackingStatus" :label="item.label" :value="item.value" :key="index" />
            </el-select>
          </div>
          <div class="flex md4">
            <div class="select-title">{{'t.searchMode' | translate}}</div>
            <el-select v-model="waybillListParams.search_mode" :placeholder="$t('t.searchMode')">
              <el-option v-for="(item, index) in searchModeOptions" :label="item.label" :value="item.value" :key="index"/>
            </el-select>
          </div>
          <div class="flex md4">
            <div class="select-title">{{'t.keyWords' | translate}}</div>
            <el-input v-model="waybillListParams.search_key" clearable :placeholder="$t('t.keyWords')"></el-input>
          </div>
        </div>

        <div class="va-row">
          <div class="flex mobile-btn mt-2">
            <button class="btn btn-primary btn-micro" @click="searchWaybill">
              <div class="btn-with-icon-content">
                <i class="ion-md-search ion"></i>
                {{ "basic.button.search" | translate }}
              </div>
            </button>
          </div>
          <div class="flex mobile-btn mt-2">
            <button class="btn btn-info btn-micro" @click="searchReset">
              <div class="btn-with-icon-content">
                <i class="ion-md-refresh ion"></i>
                {{ "basic.button.reset" | translate }}
              </div>
            </button>
          </div>
        </div>

      </vuestic-widget>
    </div>

    <div class="flex xs12 md12 w-table">
      <vuestic-widget id="dategridPayOrder">
        <div class="va-row">
            <div class="flex md6">
              <button class="btn btn-primary btn-micro" @click="batchUpload">
                <div class="btn-with-icon-content">
                  <i class="ion-md-cloud-upload ion"></i>
                  {{ "basic.button.batchUpload" | translate }}
                </div>
              </button>
            </div>
            <div class="flex md6 text-right">
              <button class="btn btn-info btn-micro mr-4" @click="downloadLogs">
                <div class="btn-with-icon-content">
                  <i class="ion-md-download ion"></i>
                  {{ "basic.button.downloadLogs" | translate }}
                </div>
              </button>
              <button class="btn btn-info btn-micro" @click="download">
                <div class="btn-with-icon-content">
                  <i class="ion-md-download ion"></i>
                  {{ "basic.button.download" | translate }}
                </div>
              </button>
            </div>
        </div>
        <div class="table-responsive mt-2" id="waybillTable">
          <table class="table table-striped first-td-padding">
            <thead>
              <tr>
                <th v-for="(item, index) in tableHeaderList" :key="index">
                  {{ item.label | translate }}
                </th>
              </tr>
            </thead>
            <tbody v-if="wayBillList">
              <tr v-for="(item, index) in wayBillList" :key="index">
                <td>
                  <span @click="fetchDetails(item.trade_no)"
                    ><a href="javascript:void(0);" class="alink">{{
                      item.trade_no
                    }}</a></span
                  >
                </td>
                <td>{{ item.out_trade_no }}</td>
                <td>
                  {{item.order_time}}
                </td>
                <td>
                  {{ item.tracking_number }}
                </td>
                <td>
                  {{ item.carrier_code }}
                </td>
                <td align="right">
                  <el-tag
                    v-if="item.tracking_status"
                    effect="dark"
                    disable-transitions
                    :type="getStatusColor(item.tracking_status)"
                    >{{ item.tracking_status }}</el-tag
                  >
                </td>
                <td align="right">
                  <el-tag
                    v-if="reviewStatusText(item.review_status)"
                    effect="dark"
                    disable-transitions
                    :type="getStatusColor(item.review_status)"
                    >{{ reviewStatusText(item.review_status) }}</el-tag
                  >
                </td>
                <td>
                  <a href="javascript:void(0);" @click="singleUpload(item)"><i class="el-icon-edit"></i>
                    {{ item.review_status == 1000 || item.review_status == 1100 ? $t('cards.link.edit') : $t('view') }}
                  </a>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="11" v-text="noData"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="block" v-if="isMobile === 'pc'">
          <pagination
            v-show="total > 0"
            :total="total"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :page.sync="page"
            :limit.sync="limit"
            @pagination="waybillData"
          />
        </div>
        <div class="block" v-else>
          <pagination
            v-show="total > 0"
            :total="total"
            layout="total, prev, pager, next"
            background
            :page.sync="page"
            :limit.sync="limit"
            @pagination="waybillData"
          />
        </div>
      </vuestic-widget>
    </div>

    <vuestic-modal :show.sync="uploadWayBillshow"
                   ref="uploadWayBill"
                   :okText="'modal.confirm2' | translate"
                   style="height: 100%;width:60vw;"
                   :okClass="'btn btn-primary btn-micro'"
                   :cancelClass="'btn btn-secondary btn-micro'"
                   :cancelText="'modal.cancel2' | translate"
                   alignModal="">
      <div slot="title">{{uploadWayBillTitle}}</div>
      <div>
        <form>
          <div class="va-row">
            <div class="flex xs12 md12">
              <fieldset>

                <div class="info-group info-disabled">
                  <div class="form-group with-icon-right"
                       :class="{'has-error': errors.has('trade_no'), 'valid': isFormFieldValid('trade_no')}">
                    <div class="input-group">
                      <input name="trade_no"
                             data-vv-as="Trade No"
                             v-model="uploadWayBill.trade_no"
                             autocomplete="off"
                             v-validate="'required'"
                             required
                             disabled />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label"
                             for="name">{{ $t("tables.detailsInfo.transactionID") }}</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('trade_no')"
                             class="help text-danger">{{ errors.first('trade_no') }}</small>
                    </div>
                  </div>
                  <div class="info-group-space"></div>
                  <div class="form-group with-icon-right"
                       :class="{'has-error': errors.has('merchantReference'), 'valid': isFormFieldValid('merchantReference')}">
                    <div class="input-group">
                      <input name="merchantReference"
                             data-vv-as="Merchant Reference"
                             v-model="uploadWayBill.merchantReference"
                             autocomplete="off"
                             v-validate="'required'"
                             required
                             disabled />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label">{{ $t("tables.listing.recurring_merchant_reference") }}</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('merchantReference')"
                             class="help text-danger">{{ errors.first('merchantReference') }}</small>
                    </div>
                  </div>
                </div>

                <div class="info-group info-disabled">
                  <div class="form-group with-icon-right"
                      v-if="!isEdit"
                       :class="{'has-error': initCarrierCountryVaild, 'valid': isCarrierCountryVaild('carrierCountry')}">
                    <div class="input-group">
                      <waybill-simple-select name="carrierCountry"
                                          data-vv-as="Carrier Region"
                                          v-validate="'required'"
                                          required
                                          :label="$t('t.carrierRegion')"
                                          v-model="uploadWayBill.carrierCountry"
                                          :options="carriersRegion"
                                          option-key="value"
                                          ref="carrierCountryInput"
                                          @input="carrierCountryForbiddenInput"
                                          autocomplete="off"
                                          :disabled="isEdit"
                                          clearable
                                           />
                                           <!-- @input="(val)=>{pepStatus = !val?true:false}" -->
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa icon-right input-icon" @click="carrierClose"></i>
                      <small v-show="initCarrierCountryVaild"
                             class="help text-danger">{{ errors.first('carrierCountry') }}</small>
                    </div>
                  </div>
                  <div class="info-group-space" v-if="!isEdit"></div>
                  <div class="form-group with-icon-right"
                       :class="{'has-error': initCarrierVaild, 'valid': isCarrierVaild('detailCarrier')}">
                    <div class="input-group">
                      <!-- Select Carrier -->
                      <!-- option-key="value" -->
                      <waybill-simple-select name="detailCarrier"
                                          data-vv-as="Carrier"
                                          v-validate="'required'"
                                          required
                                          :label="$t('t.carrier')"
                                          v-model="uploadWayBill.detailCarrier"
                                          :options="filterDetailCarriers"
                                          option-key="code"
                                          ref="carrierInput"
                                          @input="carrierForbiddenInput"
                                          autocomplete="off"
                                          :disabled="isEdit"
                                          clearable
                                           />
                                           <!-- @input="(val)=>{pepStatus = !val?true:false}" -->
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon" v-if="!isEdit"></i>
                      <i class="fa icon-right input-icon" v-if="!isEdit"></i>
                      <small v-show="initCarrierVaild" v-if="!isEdit"
                             class="help text-danger">{{ errors.first('detailCarrier') }}</small>
                    </div>
                  </div>
                </div>

                <div class="info-group info-disabled">
                  <div class="form-group with-icon-right"
                       :class="{'has-error': errors.has('trackingWebsite'), 'valid': isFormFieldValid('trackingWebsite')}">
                    <div class="input-group">
                      <input name="trackingWebsite"
                             data-vv-as="Tracking Website"
                             v-model="uploadWayBill.trackingWebsite"
                             autocomplete="off"
                             v-validate="'required'"
                             required
                             maxlength="255"
                             :disabled="isEdit" />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label"
                             for="trackingWebsite">{{ $t("waybill.trackingWebsite") }}</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('trackingWebsite')"
                             class="help text-danger">{{ errors.first('trackingWebsite') }}</small>
                    </div>
                  </div>
                  <div class="info-group-space"></div>
                  <div class="form-group with-icon-right"
                       :class="{'has-error': errors.has('trackingNo'), 'valid': isFormFieldValid('trackingNo')}">
                    <div class="input-group">
                      <input name="trackingNo"
                             data-vv-as="Tracking No"
                             v-model="uploadWayBill.trackingNo"
                             autocomplete="off"
                             v-validate="'required'"
                             required
                             :disabled="isEdit" />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label"
                             for="trackingNo">{{ $t("tables.listing.trackingNo") }}</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('trackingNo')"
                             class="help text-danger">{{ errors.first('trackingNo') }}</small>
                    </div>
                  </div>
                </div>

                <div class="info-group info-disabled">
                  <div class="form-group with-icon-right"
                       :class="{'has-error': errors.has('notes'), 'valid': isFormFieldValid('notes')}">
                    <div class="input-group">
                      <textarea name="notes"
                             data-vv-as="Notes"
                             v-model="uploadWayBill.notes"
                             autocomplete="off"
                             v-validate="'required'"
                             required
                             :disabled="isEdit" />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label"
                             for="notes">{{ $t("waybill.notes") }}</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('notes')"
                             class="help text-danger">{{ errors.first('notes') }}</small>
                    </div>
                  </div>
                </div>

                <div class="info-group info-disabled" v-if="isNotice">
                  <div class="form-group with-icon-right"
                       :class="{'has-error': errors.has('notice'), 'valid': isFormFieldValid('notice')}">
                    <div class="input-group">
                      <input name="notice"
                             :data-vv-as="`${VUE_APP_NAME} Notice`"
                             v-model="uploadWayBill.notice"
                             autocomplete="off"
                             v-validate="'required'"
                             required
                             disabled />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label"
                             for="notice">{{VUE_APP_NAME}} Notice</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('notice')"
                             class="help text-danger">{{ errors.first('notice') }}</small>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </form>
      </div>
    </vuestic-modal>


    <vuestic-modal :show.sync="uploadWayBillshow"
                   ref="uploadWayBillView"
                   :okText="'modal.confirm2' | translate"
                   style="height: 100%;width:60vw;"
                   :okClass="'btn btn-primary btn-micro'"
                   :cancelClass="'btn btn-secondary btn-micro'"
                   :cancelText="'modal.cancel2' | translate"
                   alignModal="">
      <div slot="title">{{uploadWayBillTitle}}</div>
      <div>
        <form>
          <div class="va-row">
            <div class="flex xs12 md12">
              <fieldset>

                <div class="info-group info-disabled">
                  <div class="form-group with-icon-right"
                       :class="{'has-error': errors.has('trade_no'), 'valid': isFormFieldValid('trade_no')}">
                    <div class="input-group">
                      <input name="trade_no"
                             data-vv-as="Trade No"
                             v-model="uploadWayBill.trade_no"
                             autocomplete="off"
                             v-validate="'required'"
                             required
                             disabled />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label"
                             for="name">{{ $t("tables.detailsInfo.transactionID") }}</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('trade_no')"
                             class="help text-danger">{{ errors.first('trade_no') }}</small>
                    </div>
                  </div>
                  <div class="info-group-space"></div>
                  <div class="form-group with-icon-right"
                       :class="{'has-error': errors.has('merchantReference'), 'valid': isFormFieldValid('merchantReference')}">
                    <div class="input-group">
                      <input name="merchantReference"
                             data-vv-as="Merchant Reference"
                             v-model="uploadWayBill.merchantReference"
                             autocomplete="off"
                             v-validate="'required'"
                             required
                             disabled />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label">{{ $t("tables.listing.recurring_merchant_reference") }}</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('merchantReference')"
                             class="help text-danger">{{ errors.first('merchantReference') }}</small>
                    </div>
                  </div>
                </div>

                <div class="info-group info-disabled">
                  <div class="form-group with-icon-right"
                       :class="{'has-error': initCarrierVaild, 'valid': isCarrierVaild('detailCarrier')}">
                    <div class="input-group">
                      <input name="detailCarrier"
                             data-vv-as="Carrier"
                             v-model="uploadWayBill.detailCarrier.code"
                             autocomplete="off"
                             v-validate="'required'"
                             required
                             maxlength="255"
                             :disabled="isEdit" />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label">{{ $t("t.carrier") }}</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('detailCarrier')"
                             class="help text-danger">{{ errors.first('detailCarrier') }}</small>
                    </div>
                  </div>
                  <div class="info-group-space"></div>
                  <div class="form-group with-icon-right"
                       :class="{'has-error': errors.has('trackingWebsite'), 'valid': isFormFieldValid('trackingWebsite')}">
                    <div class="input-group">
                      <input name="trackingWebsite"
                             data-vv-as="Tracking Website"
                             v-model="uploadWayBill.trackingWebsite"
                             autocomplete="off"
                             v-validate="'required'"
                             required
                             maxlength="255"
                             :disabled="isEdit" />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label"
                             for="trackingWebsite">{{ $t("waybill.trackingWebsite") }}</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('trackingWebsite')"
                             class="help text-danger">{{ errors.first('trackingWebsite') }}</small>
                    </div>
                  </div>
                </div>

                <div class="info-group info-disabled">
                  <div class="form-group with-icon-right"
                       :class="{'has-error': errors.has('trackingNo'), 'valid': isFormFieldValid('trackingNo')}">
                    <div class="input-group">
                      <input name="trackingNo"
                             data-vv-as="Tracking No"
                             v-model="uploadWayBill.trackingNo"
                             autocomplete="off"
                             v-validate="'required'"
                             required
                             :disabled="isEdit" />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label"
                             for="trackingNo">{{ $t("tables.listing.trackingNo") }}</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('trackingNo')"
                             class="help text-danger">{{ errors.first('trackingNo') }}</small>
                    </div>
                  </div>
                  <div class="info-group-space"></div>
                  <div class="form-group with-icon-right"
                       :class="{'has-error': errors.has('tracking_status'), 'valid': isFormFieldValid('tracking_status')}">
                    <div class="input-group">
                      <input name="tracking_status"
                             data-vv-as="Tracking No"
                             v-model="currentItem.tracking_status"
                             autocomplete="off"
                             v-validate="'required'"
                             required
                             :disabled="isEdit" />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label"
                             for="tracking_status">{{ $t("t.trackingStatus") }}</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('tracking_status')"
                             class="help text-danger">{{ errors.first('tracking_status') }}</small>
                    </div>
                  </div>
                </div>

                <div class="info-group info-disabled">
                  <div class="form-group with-icon-right"
                       :class="{'has-error': errors.has('tracking_submit_time'), 'valid': isFormFieldValid('tracking_submit_time')}">
                    <div class="input-group">
                      <textarea name="tracking_submit_time"
                             data-vv-as="Tracking Submit Time"
                             v-model="currentItem.tracking_submit_time"
                             autocomplete="off"
                             v-validate="'required'"
                             required
                             :disabled="isEdit" />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label"
                             for="tracking_submit_time">{{ $t("waybill.trackingSubmitTime") }}</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('tracking_submit_time')"
                             class="help text-danger">{{ errors.first('tracking_submit_time') }}</small>
                    </div>
                  </div>
                  <div class="info-group-space"></div>
                  <div class="form-group with-icon-right"
                       :class="{'has-error': errors.has('notes'), 'valid': isFormFieldValid('notes')}">
                    <div class="input-group">
                      <textarea name="notes"
                             data-vv-as="Notes"
                             v-model="uploadWayBill.notes"
                             autocomplete="off"
                             v-validate="'required'"
                             required
                             :disabled="isEdit" />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label"
                             for="notes">{{ $t("waybill.notes") }}</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('notes')"
                             class="help text-danger">{{ errors.first('notes') }}</small>
                    </div>
                  </div>
                </div>

                <div class="info-group info-disabled">
                  <div class="form-group with-icon-right">
                    <div class="input-group">
                      <textarea name="tracking_submit_time"
                             v-model="fromDetail"
                             autocomplete="off"
                             v-validate="'required'"
                             required
                             :disabled="isEdit"
                             rows="4" />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label"
                             for="tracking_submit_time">Tracking Info (From)</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('tracking_submit_time')"
                             class="help text-danger">{{ errors.first('tracking_submit_time') }}</small>
                    </div>
                  </div>
                  <div class="info-group-space"></div>
                  <div class="form-group with-icon-right">
                    <div class="input-group">
                      <textarea name="notes"
                             v-model="toDetail"
                             autocomplete="off"
                             v-validate="'required'"
                             required
                             :disabled="isEdit"
                             rows="4" />
                      <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                      <i class="fa fa-check valid-icon icon-right input-icon"></i>
                      <label class="control-label"
                             for="tracking_submit_time">Tracking Info (To)</label>
                      <i class="bar"></i>
                      <small v-show="errors.has('tracking_submit_time')"
                             class="help text-danger">{{ errors.first('tracking_submit_time') }}</small>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </form>
      </div>
    </vuestic-modal>

    <el-dialog
      :title="$t('menu.paymentOrderDetails2')"
      id="paymentDetails"
      :visible.sync="dialogTableVisible"
      style="padding-top: 3vh"
      @close="initRefund"
    >
      <div>
        <div class="va-row">
          <div class="flex xs12 md12 w-table">
            <vuestic-widget :headerText="$t('tables.details')">
              <div class="table-responsive" id="details">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>
                        {{ "tables.detailsInfo.transactionID" | translate }}
                      </th>
                      <th>{{ "tables.detailsInfo.amount" | translate }}</th>
                      <th>{{ "tables.detailsInfo.prodDesc" | translate }}</th>
                      <th>{{ "tables.detailsInfo.method" | translate }}</th>
                      <th>{{ "tables.detailsInfo.Status" | translate }}</th>
                      <th>{{ "tables.detailsInfo.createDate" | translate }}</th>
                      <!-- <th>{{'tables.detailsInfo.cbStatus' | translate}}</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(val, index) in detailInfo" :key="index">
                      <td
                        v-for="(item, i) in val"
                        :key="i"
                        :style="centerText"
                      >
                        <span v-if="detailMethod && item === 'Refund'">
                          <button
                            class="btn btn-danger btn-micro"
                            :disabled="!refundCanDo"
                            :class="{ disable: !refundCanDo }"
                            @click="showMediumModal"
                          >
                            {{ item }}
                          </button>
                        </span>
                        <span v-else-if="item === 'Callback'">
                          <button
                            class="btn btn-info btn-micro"
                            @click="callbackOrderStatus"
                            :disabled="isLoading"
                          >
                            {{ isLoading ? "" : "callback" }}
                            <span v-if="isLoading">{{ $t("loading") }}</span>
                          </button>
                        </span>
                        <span v-else-if="item === 'Match Status'">
                          <button
                            class="btn btn-info btn-micro"
                            @click="showModalFillOrder"
                            v-if="locationHost === `dashboard-test.${envName}.com`"
                          >
                            {{ item }}
                          </button>
                        </span>
                        <span v-else>
                          {{ item }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="block"></div>
            </vuestic-widget>
          </div>
        </div>

        <div class="va-row">
          <div class="flex xs12 md12">
            <vuestic-widget :headerText="$t('tables.statusHis')">
              <div class="table-responsive">
                <table class="table table-striped first-td-padding">
                  <thead>
                    <tr>
                      <th>{{ "tables.statusHisInfo.status" | translate }}</th>
                      <th>{{ "tables.statusHisInfo.date" | translate }}</th>
                      <th>{{ "tables.statusHisInfo.amount" | translate }}</th>
                      <th>{{ "tables.detailsInfo.cbStatus" | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, idx) in statusHistoryInfo" :key="idx">
                      <td :style="centerText" v-for="(sli, b) in item" :key="b">
                        <span>{{ sli }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </vuestic-widget>
          </div>
        </div>

        <div class="va-row">
          <div class="flex xs12 md6">
            <vuestic-widget :headerText="$t('tables.buyer')">
              <div class="table-responsive">
                <table class="table table-striped first-td-padding">
                  <tbody>
                    <tr
                      v-for="(bitem, bindex) in buyerInfo"
                      :key="bindex"
                      style="text-align: left"
                    >
                      <td
                        :style="sizeLeft"
                        v-for="(bval, bid) in bitem"
                        :key="bid"
                        v-if="hideBuyerTd(bid)"
                      >
                        <span
                          :class="spanWrapper"
                          v-html="
                            getVerticalTabTd(
                              bval,
                              bid,
                              'buyer',
                              Object.keys(bitem).indexOf(bid),
                              bindex
                            )
                          "
                        ></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </vuestic-widget>
          </div>
          <div class="flex xs12 md6">
            <vuestic-widget :headerText="$t('tables.merchant')">
              <div class="table-responsive" id="merchant">
                <table class="table table-striped first-td-padding">
                  <tbody>
                    <tr
                      v-for="(mitem, mkey) in merchantInfo"
                      :key="mkey"
                      style="text-align: left"
                    >
                      <td :style="sizeLeft">
                        <span
                          :class="spanWrapper"
                          v-html="getVerticalTabTd(mkey, mitem, 'merchant')"
                        ></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </vuestic-widget>
          </div>
        </div>
        <div class="va-row" v-if="transactionInfo.length > 0">
          <div class="flex xs12 md6">
            <vuestic-widget :headerText="$t('tables.transactionCost')">
              <div class="table-responsive" id="transCoat">
                <table class="table table-striped first-td-padding">
                  <thead>
                    <tr>
                      <th>
                        {{ "tables.transactionDetails.option" | translate }}
                      </th>
                      <th>
                        {{ "tables.transactionDetails.setting" | translate }}
                      </th>
                      <th>{{ "tables.transactionDetails.fee" | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(titem, idx) in transactionInfo" :key="idx">
                      <td v-for="(list, t) in titem" :key="t">
                        <span v-html="list"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </vuestic-widget>
          </div>
        </div>
        <div class="va-row" v-if="depositUpload.uploadUrl">
          <div class="flex xs12 md6">
            <vuestic-widget :headerText="$t('tables.voucher')">
              <div class="deposit-upload" id="depositUpload">
                <ul style="width: 70%">
                  <li
                    class="oneline-voucher"
                    v-for="(item, index) in payVouchers"
                    :key="index"
                  >
                    <span class="key col-md-5" v-text="item.name"></span>
                    <span class="key col-md-5" v-text="item.time"></span>
                    <a
                      v-if="item.url"
                      :href="item.url"
                      @click="downloadAttachment(item, $event)"
                      class="iconicstroke iconicstroke-download"
                      style="font-size: 24px; cursor: pointer"
                    ></a
                    ><!-- TODO 下载的图标 -->
                  </li>
                </ul>
                <a
                  :href="depositUpload.uploadUrl"
                  target="_blank"
                  class="btn btn-primary btn-micro pull-right"
                  >{{ $t("basic.button.upload") }}</a
                >
              </div>
            </vuestic-widget>
          </div>
        </div>
        <div class="va-row" v-if="refusedFg">
          <div class="flex xs12 md6">
            <vuestic-widget :headerText="$t('tables.antiFraud')">
              <div class="refused-info">
                <ul style="width: 70%">
                  <li class="oneline-voucher">
                    <span>{{ $t("tables.refusedInfo") }}</span>
                    <span v-text="refusedInfo"></span>
                  </li>
                </ul>
              </div>
            </vuestic-widget>
          </div>
        </div>
      </div>

      <div class="modals-page" id="refundReason">
        <vuestic-modal
          :show.sync="show"
          ref="mediumModal"
          :okText="'modal.confirm2' | translate"
          style="height: 100%; width: 60vw"
          :okClass="'btn btn-primary btn-micro'"
          :cancelClass="'btn btn-secondary btn-micro'"
          :cancelText="'modal.cancel2' | translate"
          @cancel="handleModalClose"
        >
          <div slot="title">{{ "modal.refundReason" | translate }}</div>
          <div>
            <form>
              <div class="va-row">
                <div class="flex xs12 md12">
                  <fieldset>
                    <div
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('refundAmount'),
                        valid: isFormFieldValid('refundAmount'),
                      }"
                    >
                      <div class="input-group">
                        <input
                          id="simple-input"
                          name="refundAmount"
                          data-vv-as="Name"
                          v-model="refundAmount"
                          v-validate="'required'"
                          autocomplete="off"
                          required
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="simple-input"
                          >{{
                            "forms.inputs.refundAmount" | translate
                          }}：</label
                        ><i class="bar"></i>
                        <small
                          v-show="errors.has('refundAmount')"
                          class="help text-danger"
                        >
                          {{ errors.first("refundAmount") }}
                        </small>
                      </div>
                    </div>
                    <div
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('successfulEmail'),
                        valid: isSuccessfulEmailValid,
                      }"
                    >
                      <div class="input-group">
                        <input
                          id="successfulEmail"
                          name="successfulEmail"
                          v-model="successfulEmail"
                          v-validate="'required|email'"
                          autocomplete="off"
                          required
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="successfulEmail">
                          {{ "forms.inputs.buyerEmail" | translate }}：
                        </label>
                        <i class="bar" />
                        <small
                          v-show="errors.has('successfulEmail')"
                          class="help text-danger"
                        >
                          {{ errors.first("successfulEmail") }}
                        </small>
                      </div>
                    </div>

                    <div
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('refundExplain'),
                        valid: isFormFieldValid('refundExplain'),
                      }"
                    >
                      <div class="flex md12 xs12" id="textareawrapper">
                        <div class="input-group">
                          <textarea
                            type="text"
                            name="refundExplain"
                            data-vv-as="Name"
                            id="simple-textarea"
                            v-model="refundExplain"
                            :placeholder="$t('payment.upTo100Characters')"
                            maxlength="100"
                            rows="2"
                            :style="paddTop"
                            @focus="resizeLabel"
                            @blur="focusLabel"
                            v-validate="'required'"
                            required
                          >
                          </textarea>
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <label class="control-label" for="simple-textarea"
                            >{{
                              "forms.inputs.description" | translate
                            }}：</label
                          ><i class="bar"></i>
                          <small
                            v-show="errors.has('refundExplain')"
                            class="help text-danger"
                          >
                            {{ errors.first("refundExplain") }}
                          </small>
                        </div>
                      </div>
                    </div>
                    <div
                      class="form-group with-icon-right"
                      v-if="speiFlag"
                      :class="{
                        'has-error': errors.has('bank'),
                        valid: isFormFieldValid('bank'),
                      }"
                    >
                      <div class="input-group">
                        <el-select
                          id="bank"
                          name="bank"
                          v-model="bankCode"
                          :filterable="true"
                          v-validate="'required'"
                          required
                          :placeholder="$t('payment.pleaseSelectABank')"
                          @change="selectBankCode"
                        >
                          <el-option
                            v-for="item in bankCodeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <i class="bar" />
                        <small
                          v-show="errors.has('bank')"
                          class="help text-danger"
                        >
                          {{ errors.first("bank") }}
                        </small>
                      </div>
                    </div>
                    <div
                      class="form-group with-icon-right"
                      v-if="speiFlag"
                      :class="{
                        'has-error': errors.has('clabe'),
                        valid: isFormFieldValid('clabe'),
                      }"
                    >
                      <div class="input-group">
                        <input
                          id="clabe"
                          name="clabe"
                          v-model="clabe"
                          v-validate="'required'"
                          autocomplete="off"
                          required
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="clabe">
                          CLABE：
                        </label>
                        <i class="bar" />
                        <small
                          v-show="errors.has('clabe')"
                          class="help text-danger"
                        >
                          {{ errors.first("clabe") }}
                        </small>
                      </div>
                    </div>

                    <!-- 这一块打算添加上对现金支付的申请用的字段 TODO -->
                    <vuestic-checkbox
                      ref="other"
                      v-if="checkCanRefund() && !speiFlag"
                      :label="$t('forms.controls.options')"
                      v-model="checkboxOption"
                    />
                    <div id="user_info" class="" v-if="dispalyOtherFg">
                      <div
                        class="form-group with-icon-right"
                        :class="{
                          'has-error': errors.has('username'),
                          valid: isFormFieldValid('username'),
                        }"
                      >
                        <div class="input-group">
                          <input
                            id="uname-input"
                            name="username"
                            data-vv-as="Name"
                            v-model="username"
                            v-validate="'required'"
                            required
                          />
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <label class="control-label" for="uname-input"
                            >{{ "forms.inputs.username" | translate }}：</label
                          ><i class="bar"></i>
                          <small
                            v-show="errors.has('username')"
                            class="help text-danger"
                          >
                            {{ errors.first("username") }}
                          </small>
                        </div>
                      </div>
                      <div
                        class="form-group with-icon-right"
                        :class="{
                          'has-error': errors.has('cpfNO'),
                          valid: isFormFieldValid('cpfNO'),
                        }"
                      >
                        <div class="input-group">
                          <input
                            id="cpfNO-input"
                            name="cpfNO"
                            data-vv-as="Name"
                            v-model="cpfNO"
                            v-validate="'required'"
                            maxlength="14"
                            required
                          />
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <label class="control-label" for="cpfNO-input"
                            >{{ "forms.inputs.cpfNO" | translate }}：</label
                          ><i class="bar"></i>
                          <small
                            v-show="errors.has('cpfNO')"
                            class="help text-danger"
                          >
                            {{ errors.first("cpfNO") }}
                          </small>
                        </div>
                      </div>
                      <div
                        class="form-group with-icon-right"
                        :class="{
                          'has-error': errors.has('agency'),
                          valid: isFormFieldValid('agency'),
                        }"
                      >
                        <div class="input-group">
                          <input
                            id="agency-input"
                            name="agency"
                            data-vv-as="Name"
                            v-model="agency"
                            v-validate="'required'"
                            maxlength="6"
                            onkeyup="this.value=this.value.replace(/[^a-zA-Z0-9\-]/g,'')"
                            ondragenter="return false"
                            ondragover="return false"
                            required
                          />
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <label class="control-label" for="agency-input"
                            >{{ "forms.inputs.agency" | translate }}：</label
                          ><i class="bar"></i>
                          <small
                            v-show="errors.has('agency')"
                            class="help text-danger"
                          >
                            {{ errors.first("agency") }}
                          </small>
                        </div>
                      </div>
                      <div
                        class="form-group with-icon-right"
                        id="bankWrapper"
                        :class="{
                          'has-error': initSelectedVaild,
                          valid: isBankVaild(selBank),
                        }"
                      >
                        <div class="input-group">
                          <vuestic-simple-select
                            :label="$t('forms.inputs.bank')"
                            name="selBank"
                            data-vv-as="Name"
                            v-model="selBank"
                            ref="bankInput"
                            @input="forbiddenInput"
                            autocomplete="off"
                            v-validate="'required'"
                            required
                            option-key="description"
                            v-bind:options="bankOptions"
                          />
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <small
                            v-show="initSelectedVaild"
                            class="help text-danger"
                            style="display: block; margin-top: -30px"
                          >
                            {{ errors.first("selBank") }}
                          </small>
                        </div>
                      </div>
                      <div
                        class="form-group with-icon-right"
                        id="accountWrapper"
                        :class="{
                          'has-error': initSelAccoutTypeVaild,
                          valid: isAccountVaild(accountType),
                        }"
                      >
                        <div class="input-group">
                          <vuestic-simple-select
                            :label="$t('forms.inputs.accountType')"
                            name="accountType"
                            data-vv-as="Name"
                            v-model="accountType"
                            ref="accountInput"
                            @input="forbiddenAccountInput"
                            autocomplete="off"
                            v-validate="'required'"
                            required
                            option-key="description"
                            v-bind:options="accountOptions"
                          />
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <small
                            v-show="initSelAccoutTypeVaild"
                            class="help text-danger"
                            style="display: block; margin-top: -30px"
                          >
                            {{ errors.first("accountType") }}
                          </small>
                        </div>
                      </div>
                      <div class="form-group with-icon-right">
                        <div class="input-group">
                          <input
                            id="card_number"
                            name="card_number"
                            data-vv-as="Name"
                            v-model="bankAccountNumberFirst"
                            v-validate="'required'"
                            style="display: inline-block; width: 60%"
                            onpaste="return false"
                            ondragenter="return false"
                            ondragover="return false"
                            maxlength="14"
                            @focus="formatCardNumber($event)"
                            required
                          />
                          <span>—</span>
                          <input
                            id="branch_num"
                            name="branch_num"
                            data-vv-as="Name"
                            v-model="bankAccountNumberLast"
                            v-validate="'required'"
                            style="
                              display: inline-block;
                              width: 20%;
                              padding-left: 10px;
                            "
                            maxlength="2"
                            onkeyup="this.value=this.value.replace(/\D/g,'')"
                            onkeydown="this.value=this.value.replace(/\D/g,'')"
                            onpaste="return false"
                            ondragenter="return false"
                            ondragover="return false"
                            required
                          />
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <label class="control-label" for="card_number"
                            >{{
                              "forms.inputs.bankAccountNumber" | translate
                            }}：</label
                          ><i class="bar"></i>
                        </div>
                      </div>
                    </div>
                    <div
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('userPass'),
                        valid: isFormFieldValid('userPass'),
                      }"
                    >
                      <div class="input-group">
                        <input
                          name="userPass"
                          data-vv-as="Password"
                          type="password"
                          id="password"
                          v-model="userPass"
                          v-validate="'required'"
                          required="required"
                          onkeyup="value=value.replace(/\s/g,'')"
                          onkeydown="value=value.replace(/\s/g,'')"
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="password">
                          {{ $t("auth.password") }}：
                        </label>
                        <i class="bar" />
                        <small
                          v-show="errors.has('userPass')"
                          class="help text-danger"
                          >{{ errors.first("userPass") }}</small
                        >
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
        </vuestic-modal>
      </div>

      <div class="modals-page" id="fillOrder">
        <vuestic-modal
          :show.sync="show"
          ref="fillOrderModal"
          :okText="'modal.confirm2' | translate"
          style="height: 100%; width: 60vw"
          :okClass="'btn btn-primary btn-micro'"
          :cancelClass="'btn btn-secondary btn-micro'"
          :cancelText="'modal.cancel2' | translate"
          @cancel="fillOrderModalClose"
        >
          <div slot="title">{{ "modal.fillOrder" | translate }}</div>
          <div>
            <form>
              <div class="va-row">
                <div class="flex xs12 md12">
                  <fieldset>
                    <div
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('orderStatus'),
                        valid: isFormFieldValid('orderStatus'),
                      }"
                    >
                      <div class="input-group">
                        <el-select
                          id="orderStatus"
                          name="orderStatus"
                          data-vv-as="status"
                          v-model="fillStatus"
                          :filterable="true"
                          v-validate="'required'"
                          required
                          :placeholder="$t('pleaseSelectStatus')"
                          @change="selectStatusCode"
                        >
                          <el-option
                            v-for="item in statusOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <i class="bar" />
                        <small
                          v-show="errors.has('orderStatus')"
                          class="help text-danger"
                        >
                          {{ errors.first("orderStatus") }}
                        </small>
                      </div>
                    </div>

                    <div
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('userPass'),
                        valid: isFormFieldValid('userPass'),
                      }"
                    >
                      <div class="input-group">
                        <input
                          name="userPass"
                          data-vv-as="Password"
                          type="password"
                          id="password"
                          v-model="userPass"
                          v-validate="'required'"
                          required="required"
                          onkeyup="value=value.replace(/\s/g,'')"
                          onkeydown="value=value.replace(/\s/g,'')"
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="password">
                          {{ $t("auth.password") }}：
                        </label>
                        <i class="bar" />
                        <small
                          v-show="errors.has('userPass')"
                          class="help text-danger"
                          >{{ errors.first("userPass") }}</small
                        >
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
        </vuestic-modal>
      </div>

      <div class="flex xs12 md6 flex-center" v-if="isToastContentPresent">
        <div class="toasted-container sample-toasted-container shrink">
          <div class="toasted vuestic-toast none default">
            <i class="fa" :class="toastIcon" v-if="toastIcon" />
            {{ toastText }}
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
//  增加详情页面
import {
  request,
  formatUserCredentials,
  downloadImage,
} from "@/utils/utils.js";
import { translateDetailLabel as mapDetailLabel } from "@/utils/detailLabel.js";
import Scrollbar from "@/vuestic-theme/vuestic-components/vuestic-scrollbar/VuesticScrollbar.vue";
import waybillSimpleSelect from "@/vuestic-theme/vuestic-components/waybill-simple-select/VuesticKycSelect.vue";

import TableFiledsSettings from "@/package/TableFiledsSettings.vue";

import Pagination from "@/components/Pagination";

import { Dialog } from "element-ui";
import { findElements } from '@fullcalendar/core';
var moment = require("moment-timezone");
var zoneObj = {};
export default {
  name: "WayBillList",
  components: {
    TableFiledsSettings,
    Pagination,
    Scrollbar, //  增加详情页面
    waybillSimpleSelect,
  },
  data() {
    return {
      // -------------------
      bankCodeList: [
        {
          value: "2001",
          label: "BANXICO",
        }
      ],
      selectedBank: {},
      bankCode: "",
      speiFlag: false,
      isLoading: false,
      tzOptions: [
        // { label: 'Etc/GMT-12', value: 'Etc/GMT-12' },
        // { label: 'Etc/GMT-11', value: 'Etc/GMT-11' },
        // { label: 'Etc/GMT-10', value: 'Etc/GMT-10' },
        // { label: 'Etc/GMT-9', value: 'Etc/GMT-9' },
        { label: "Asia/Shanghai", value: "Etc/GMT-8" },
        // { label: 'Etc/GMT-7', value: 'Etc/GMT-7' },
        // { label: 'Etc/GMT-6', value: 'Etc/GMT-6' },
        // { label: 'Etc/GMT-5', value: 'Etc/GMT-5' },
        // { label: 'Etc/GMT-4', value: 'Etc/GMT-4' },
        // { label: 'Etc/GMT-3', value: 'Etc/GMT-3' },
        // { label: 'Etc/GMT-2', value: 'Etc/GMT-2' },
        // { label: 'Etc/GMT-1', value: 'Etc/GMT-1' },
        { label: "Etc/GMT", value: "Etc/GMT" },
        // { label: 'Etc/GMT+1', value: 'Etc/GMT+1' },
        // { label: 'Etc/GMT+2', value: 'Etc/GMT+2' },
        { label: "America/Sao_Paulo", value: "Etc/GMT+3" },
        // { label: 'Etc/GMT+4', value: 'Etc/GMT+4' },
        // { label: 'Etc/GMT+5', value: 'Etc/GMT+5' },
        { label: "America/Mexico_City", value: "Etc/GMT+6" },
        // { label: 'Etc/GMT+7', value: 'Etc/GMT+7' },
        // { label: 'Etc/GMT+8', value: 'Etc/GMT+8' },
        // { label: 'Etc/GMT+9', value: 'Etc/GMT+9' },
        // { label: 'Etc/GMT+10', value: 'Etc/GMT+10' },
        // { label: 'Etc/GMT+11', value: 'Etc/GMT+11' },
        // { label: 'Etc/GMT+12', value: 'Etc/GMT+12' },
      ],
      sctedTableColumns: [],
      showColumnsList: {
        transactionId: true,
        merchantReference: true,
        appName: true,
        referenceDateTime: true,
        method: true,
        amount: true,
        status: true,
        muid: true,
        email: true,
        subject: true,
        updateTime: true,
      },
      appList: "",
      currencyList: "",
      methodList: "",
      modeList: {
        "Transaction ID": "1",
        "Merchant Reference": "2",
        "Partner ID": "3",
        "Merchant UID": "4",
        Email: "5",
        "User Identify": "6",
      },
      timeModeList: {
        "Create Time": "1",
        "Update Time": "2",
      },
      statusList: [],
      value_cur: "",
      value_method: "",
      value_status: "",
      dateDetails: [],
      timeZoneList: [
        "America/Sao_Paulo",
        "Etc/GMT",
        "Asia/Shanghai",
        "America/Mexico_City",
        "America/Bogota", // 哥伦比亚
        "America/Santiago", // 智利 America/Santiago 首都  Pacific/Easter America/Punta_Arenas
        "America/Lima", // 秘鲁
        "America/Panama", // 巴拿马
        "America/Costa_Rica", // 哥斯达黎加
        "America/Guayaquil", // 厄瓜多尔 America/Guayaquil Pacific/Galapagos
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() + 24 * 60 * 60 * 1000;
        },
      },
      recordTime2country: [],
      changeDateFg: false,
      queryDate: {
        start_time: "",
        end_time: "",
      },

      // 增加详情页面
      dialogTableVisible: false,
      show: true,
      single: [],
      detailInfo: [[], []],
      out_trade_no: '',
      app_id: '',
      statusHistoryInfo: [[]],
      transactionInfo: [
        // ['Transaction Fee Rate Success', '5%', 'BRL 5.00']
      ],
      depositUpload: {
        uploadUrl: "", // 'http://www.baidu.com/'
      },
      buyerInfo: [
        /* { 'NAME': 'Hiago Azevedo Gritti', 'CPF': '14354478757' },
        { 'MUID': '12345678', 'Email': 'xxxxx@gmail.com' },  trans_base.payment_info:
        { 'CEP': '12345', 'Phone Number': '055-2333454' } */
        { NAME: "", CPF: "" },
        { MUID: "", Email: "" },
        { CEP: "", "Phone Number": "" },
      ],
      deviceInfo: {
        /* 'System': 'Windows 10',
        'Resolution': '1366*768',
        'Browser': 'Chrome',
        'IP': '177.207.192.143(Brazil)' */
      },
      merchantInfo: {
        "App Name": "",
        "App ID": "",
        "Merchant Reference": "",
      },
      spanWrapper: "span-wrapper",
      verticalTitle: "vertical-title",
      leftText: {
        textAlign: "left",
      },
      sizeLeft: {
        display: "inline-block",
        textAlign: "left",
        "min-width": "120px",
      },
      rigthText: {
        textAlign: "right",
      },
      centerText: {
        textAlign: "center",
      },
      mgr: {
        marginRight: "30px",
      },
      mgr2: {
        marginRight: "60px",
        visibility: "hidden",
      },
      paddTop: {
        "padding-top": "18px",
      },
      refundAmount: "",
      successfulEmail: "",
      clabe: "",
      refundExplain: "",
      userPass: "",
      toastText: "Application for refund has been submitted!",
      toastIcon: "fa-star-o",
      toastPosition: "top-center",
      isToastFullWidth: false,
      toastDuration: 2500,
      isToastContentPresent: false,
      loading: null,
      refundCanDo: true,
      downLoading: null,
      searching: null,
      payVouchers: [
        {
          name: "Payment Voucher",
          time: "N/A",
          url: "",
        },
        {
          name: "Personal I.D.",
          time: "N/A",
          url: "",
        },
        {
          name: "Proof of Address",
          time: "N/A",
          url: "",
        },
      ],
      checkboxOption: false,
      username: "",
      cpfNO: "",
      agency: "",
      bankStatus: false,
      selBank: "",
      bankOptions: [
        { id: 1, description: "Banco Caixa Economica Federal", value: "104" },
        { id: 2, description: "Banco do Brasil", value: "001" },
        { id: 3, description: "Banco Bradesco", value: "237" },
        { id: 4, description: "Banco Itau", value: "341" },
        { id: 5, description: "Banco Santander", value: "033" },
        { id: 6, description: "AGIPLAN", value: "121" },
        { id: 7, description: "Banco BMG", value: "318" },
        { id: 8, description: "Banco Bonsucesso", value: "218" },
        { id: 9, description: "Banco BRB de Brasília", value: "070" },
        { id: 10, description: "Banco Citibank", value: "745" },
        { id: 11, description: "Banco Cooperativa do Brasil", value: "756" },
        { id: 12, description: "Banco Cooperativa Sicred", value: "748" },
        { id: 13, description: "Banco da Amazonia", value: "003" },
        { id: 14, description: "BANCO DAYCOVAL S.A.", value: "707" },
        {
          id: 15,
          description: "Banco do Estado de Santa Catarina",
          value: "087",
        },
        { id: 16, description: "Banco do Estado de Sergipe", value: "047" },
        {
          id: 17,
          description: "Banco do Estado do Rio Grande do Sul",
          value: "041",
        },
        { id: 18, description: "Banco do Nordeste do Brasil", value: "004" },
        { id: 19, description: "Banco HSBC", value: "399" },
        { id: 20, description: "Banco Indusval", value: "653" },
        { id: 21, description: "Banco Intermedium S.A.", value: "077" },
        { id: 22, description: "Banco Mercantil do Brasil", value: "389" },
        { id: 23, description: "Banco Nubank", value: "260" },
        { id: 24, description: "Banco Original S.A.", value: "212" },
        { id: 25, description: "Banco Rendimento", value: "633" },
        { id: 26, description: "Banco Safra", value: "422" },
        { id: 27, description: "Banco Votorantim", value: "655" },
        {
          id: 28,
          description: "Banestes SA - Banco do Estado do Espírito Santo",
          value: "021",
        },
        { id: 29, description: "Bank of America", value: "755" },
        {
          id: 30,
          description: "Cooperativa Central de Crédito Urbano Cecred",
          value: "085",
        },
        { id: 31, description: "Cooperativa Unicred Central SP", value: "090" },
        {
          id: 32,
          description: "Cooperativa Unicred de Sete Lagoas",
          value: "136",
        },
        { id: 33, description: "CRESOL Confederacao", value: "133" },
        { id: 34, description: "Parana Banco", value: "254" },
        { id: 35, description: "Unicred Norte do Paraná", value: "084" },
      ],
      accountType: "",
      aTypeStatus: false,
      accountOptions: [
        { id: 1, description: "Conta corrente", value: "checking_account" },
        { id: 2, description: "Conta poupança", value: "savings_account" },
      ],
      bankAccountNumberFirst: "",
      bankAccountNumberLast: "",
      dispalyOtherFg: false,
      refusedInfo: "error",
      refusedFg: false,
      detailMethod: "",
      // Match Status
      fillStatus: "",
      statusOptions: [
        // { label: 'Initial', value: '10001' },
        // { label: 'Processing', value: '18000' },
        // { label: 'Cancelled', value: '25000' },
        { label: 'Success', value: '20000' },
        // { label: 'Dispute', value: '30000' },
        { label: 'Refused', value: '21000' },
        // { label: 'Refunded', value: '22000' },
        { label: 'ChargeBack', value: '23000' },
        // { label: 'ChargebackReversed', value: '23001' },
        // { label: 'RiskControl', value: '27000' },
      ],
      selectedStatus: {},
      // 新增
      carriersRegion: [
        {id: "all-carrier-countries", value: "All Carrier Countries"},
        {id: "only-global", value: "Global"}
      ],
      carriers: [],
      filterCarriers: [],
      filterDetailCarriers: [],
      carrierRegion: {id: "all-carrier-countries", value: "All Carrier Countries"},
      isTimeZoned: true,
      trackingStatus: [
        {value: '', label: 'All Tracking Status'},
        {value: 'pending', label: 'pending'},
        {value: 'notfound', label: 'notfound'},
        {value: 'transit', label: 'transit'},
        {value: 'pickup', label: 'pickup'},
        {value: 'delivered', label: 'delivered'},
        {value: 'expired', label: 'expired'},
        {value: 'undelivered', label: 'undelivered'},
        {value: 'exception', label: 'exception'},
        {value: 'InfoReceived', label: 'InfoReceived'},
      ],
      searchModeOptions: [
        {value: '1', label: 'Transaction ID'},
        {value: '2', label: 'Merchant Reference'},
      ],
      dateModeOptions: [
        {value: '', label: 'Select Date Mode'},
        {value: '1', label: 'Create Time'},
        {value: '2', label: 'Tracking Submit Time'},
      ],
      timeZoneOptions: [
        {value: 'Etc/GMT+3', label: 'America/Sao_Paulo'},
        {value: 'Etc/GMT', label: 'Etc/GMT'},
        {value: 'Etc/GMT-8', label: 'Asia/Shanghai'},
        {value: 'Etc/GMT+6', label: 'America/Mexico_City'},
      ],
      waybillListParams: {
        review_status: '',
        carrier_code: '',
        tracking_status: '',
        search_mode: '1',
        search_key: '',
        date_mode: '',
        zone_id: '',
        time: [],
        page_num: 1,
        page_size: 10,
        app_id: ""
      },
      uploadWayBill: {
        trade_no: "",
        merchantReference: "",
        notice: "",
        detailCarrier: {},
        carrierCountry: {id: "all-carrier-countries", value: "All Carrier Countries"},
        trackingWebsite: "",
        trackingNo: "",
        notes: "",
      },
      tableColumns: [
        { label: "tables.listing.recurring_transaction_id", key: "transactionId", id: 0 },
        { label: "tables.listing.recurring_merchant_reference", key: "merchantReference", id: 1 },
        { label: "tables.listing.app_name", key: "appName", id: 2 },
        { label: "tables.listing.recurring_create_time", key: "referenceDateTime", id: 3 },
        { label: "t.method", key: "method", id: 4 },
        { label: "t.amount", key: "amount", id: 5 },
        { label: "t.status", key: "status", id: 6 },
        { label: "tables.listing.muid", key: "muid", id: 7 },
        { label: "tables.listing.email", key: "email", id: 8 },
        { label: "tables.listing.subject", key: "subject", id: 9 },
        { label: "tables.listing.updateTime", key: "update Time", id: 10 },
      ],
      // tableHeaderList: [],
      wayBillList: null, // 请求回来填充表格的数据
      total: 0, // 数据总条数
      page: 1, // 默认显示第1页
      limit: 10, // 默认一次显示10条数据
      noData: this.$t("t.noDataNoOrder"),
      uploadWayBillshow: true,
      uploadWayBillTitle: "Waybill Detail",
      detailCarrierStatus: false,
      carrierCountryStatus: false,
      isNotice: false,
      isEdit: false,
      currentItem: {}, // 当前的单条数据

      // 增加详情页面
      dialogTableVisible: false,
      show: true,
      single: [],
      detailInfo: [[], []],
      out_trade_no: '',
      app_id: '',
      statusHistoryInfo: [[]],
      transactionInfo: [
        // ['Transaction Fee Rate Success', '5%', 'BRL 5.00']
      ],
      depositUpload: {
        uploadUrl: "", // 'http://www.baidu.com/'
      },
      buyerInfo: [
        /* { 'NAME': 'Hiago Azevedo Gritti', 'CPF': '14354478757' },
        { 'MUID': '12345678', 'Email': 'xxxxx@gmail.com' },  trans_base.payment_info:
        { 'CEP': '12345', 'Phone Number': '055-2333454' } */
        { NAME: "", CPF: "" },
        { MUID: "", Email: "" },
        { CEP: "", "Phone Number": "" },
      ],
      deviceInfo: {
        /* 'System': 'Windows 10',
        'Resolution': '1366*768',
        'Browser': 'Chrome',
        'IP': '177.207.192.143(Brazil)' */
      },
      merchantInfo: {
        "App Name": "",
        "App ID": "",
        "Merchant Reference": "",
      },
      spanWrapper: "span-wrapper",
      verticalTitle: "vertical-title",
      leftText: {
        textAlign: "left",
      },
      sizeLeft: {
        display: "inline-block",
        textAlign: "left",
        "min-width": "120px",
      },
      rigthText: {
        textAlign: "right",
      },
      centerText: {
        textAlign: "center",
      },
      mgr: {
        marginRight: "30px",
      },
      mgr2: {
        marginRight: "60px",
        visibility: "hidden",
      },
      paddTop: {
        "padding-top": "18px",
      },
      refundAmount: "",
      successfulEmail: "",
      clabe: "",
      refundExplain: "",
      userPass: "",
      toastText: "Application for refund has been submitted!",
      toastIcon: "fa-star-o",
      toastPosition: "top-center",
      isToastFullWidth: false,
      toastDuration: 2500,
      isToastContentPresent: false,
      loading: null,
      refundCanDo: true,
      downLoading: null,
      searching: null,
      payVouchers: [
        {
          name: "Payment Voucher",
          time: "N/A",
          url: "",
        },
        {
          name: "Personal I.D.",
          time: "N/A",
          url: "",
        },
        {
          name: "Proof of Address",
          time: "N/A",
          url: "",
        },
      ],
      checkboxOption: false,
      username: "",
      cpfNO: "",
      agency: "",
      bankStatus: false,
      selBank: "",
      bankOptions: [
        { id: 1, description: "Banco Caixa Economica Federal", value: "104" },
        { id: 2, description: "Banco do Brasil", value: "001" },
        { id: 3, description: "Banco Bradesco", value: "237" },
        { id: 4, description: "Banco Itau", value: "341" },
        { id: 5, description: "Banco Santander", value: "033" },
        { id: 6, description: "AGIPLAN", value: "121" },
        { id: 7, description: "Banco BMG", value: "318" },
        { id: 8, description: "Banco Bonsucesso", value: "218" },
        { id: 9, description: "Banco BRB de Brasília", value: "070" },
        { id: 10, description: "Banco Citibank", value: "745" },
        { id: 11, description: "Banco Cooperativa do Brasil", value: "756" },
        { id: 12, description: "Banco Cooperativa Sicred", value: "748" },
        { id: 13, description: "Banco da Amazonia", value: "003" },
        { id: 14, description: "BANCO DAYCOVAL S.A.", value: "707" },
        {
          id: 15,
          description: "Banco do Estado de Santa Catarina",
          value: "087",
        },
        { id: 16, description: "Banco do Estado de Sergipe", value: "047" },
        {
          id: 17,
          description: "Banco do Estado do Rio Grande do Sul",
          value: "041",
        },
        { id: 18, description: "Banco do Nordeste do Brasil", value: "004" },
        { id: 19, description: "Banco HSBC", value: "399" },
        { id: 20, description: "Banco Indusval", value: "653" },
        { id: 21, description: "Banco Intermedium S.A.", value: "077" },
        { id: 22, description: "Banco Mercantil do Brasil", value: "389" },
        { id: 23, description: "Banco Nubank", value: "260" },
        { id: 24, description: "Banco Original S.A.", value: "212" },
        { id: 25, description: "Banco Rendimento", value: "633" },
        { id: 26, description: "Banco Safra", value: "422" },
        { id: 27, description: "Banco Votorantim", value: "655" },
        {
          id: 28,
          description: "Banestes SA - Banco do Estado do Espírito Santo",
          value: "021",
        },
        { id: 29, description: "Bank of America", value: "755" },
        {
          id: 30,
          description: "Cooperativa Central de Crédito Urbano Cecred",
          value: "085",
        },
        { id: 31, description: "Cooperativa Unicred Central SP", value: "090" },
        {
          id: 32,
          description: "Cooperativa Unicred de Sete Lagoas",
          value: "136",
        },
        { id: 33, description: "CRESOL Confederacao", value: "133" },
        { id: 34, description: "Parana Banco", value: "254" },
        { id: 35, description: "Unicred Norte do Paraná", value: "084" },
      ],
      accountType: "",
      aTypeStatus: false,
      accountOptions: [
        { id: 1, description: "Conta corrente", value: "checking_account" },
        { id: 2, description: "Conta poupança", value: "savings_account" },
      ],
      bankAccountNumberFirst: "",
      bankAccountNumberLast: "",
      dispalyOtherFg: false,
      refusedInfo: "error",
      refusedFg: false,
      detailMethod: "",
      fromDetail: '',
      toDetail: '',
      locationHost: '',
      VUE_APP_NAME: process.env.VUE_APP_NAME
    };
  },
  watch: {
    checkboxOption: {
      handler: function (newVal, oldVal) {
        if (newVal === true) {
          this.dispalyOtherFg = true;
        } else {
          this.dispalyOtherFg = false;
        }
      },
      immediate: true,
      deep: true,
    },
    cpfNO: {
      handler: function (newVal, oldVal) {
        if (newVal.length === 4) {
          this.cpfNO = oldVal + "." + newVal.substring(3);
        }
        if (newVal.length === 8) {
          this.cpfNO = oldVal + "." + newVal.substring(7);
        }
        if (newVal.length === 12) {
          this.cpfNO = oldVal + "-" + newVal.substring(11);
        }
      },
      immediate: true,
      deep: true,
    },
    bankAccountNumberFirst: {
      handler: function (newVal, oldVal) {
        if (newVal.length === 4) {
          this.bankAccountNumberFirst += " ";
        }
        if (newVal.length === 9) {
          this.bankAccountNumberFirst += " ";
        }
      },
      immediate: true,
      deep: true,
    },
    uploadWayBill: {
      handler: function (newVal, oldVal) {
        if (newVal.carrierCountry.value == "All Carrier Countries") {
          this.filterDetailCarriers = this.carriers
        }
      },
      immediate: true,
      deep: true,
    },
    waybillListParams: {
      handler: function (newVal, oldVal) {
        if (newVal.time.length == 0) return
        if (!newVal.zone_id) return
        let tzZones = {
          'Etc/GMT-8': 'Asia/Shanghai',
          'Etc/GMT': 'Etc/GMT',
          'Etc/GMT+3': 'America/Sao_Paulo',
          'Etc/GMT+6': 'America/Mexico_City',
        }
        // zone_id
        this.queryDate.start_time = moment
        .tz(moment.tz(newVal.time[0], tzZones[newVal.zone_id]), "UTC")
        .format("YYYY-MM-DD HH:mm:ss");
        this.queryDate.end_time = moment
          .tz(moment.tz(newVal.time[1], tzZones[newVal.zone_id]), "UTC")
          .format("YYYY-MM-DD HH:mm:ss");

        // time
        this.queryDate.start_time = moment
          .tz(moment.tz(newVal.time[0], tzZones[newVal.zone_id]), "UTC")
          .format("YYYY-MM-DD HH:mm:ss");
        this.queryDate.end_time = moment
          .tz(moment.tz(newVal.time[1], tzZones[newVal.zone_id]), "UTC")
          .format("YYYY-MM-DD HH:mm:ss");
      },
      immediate: true,
      deep: true,
    },
  },
  // 增加详情页面
  computed: {
    isSuccessfulEmailValid() {
      let isValid = false;
      if (this.formFields.successfulEmail) {
        isValid =
          this.formFields.successfulEmail.validated &&
          this.formFields.successfulEmail.valid;
      }
      return isValid;
    },
    isMobile: function () {
      if (document.body.clientWidth && document.body.clientWidth < 750) {
        return "mobile";
      }
      return "pc";
    },
    initCarrierVaild () {
      return this.detailCarrierStatus
    },
    initCarrierCountryVaild() {
      return this.carrierCountryStatus
    },
    initSelectedVaild() {
      return this.bankStatus;
    },
    initSelAccoutTypeVaild() {
      return this.aTypeStatus;
    },
    envName() {
      return process.env.VUE_APP_NAME.toLowerCase()
    },
    tableHeaderList () {
      return [
        { label: this.$t('tables.listing.recurring_transaction_id'), key: "transactionId", id: 0 },
        {
          label: this.$t('tables.listing.recurring_merchant_reference'),
          key: "merchantReference",
          id: 1,
        },
        { label: this.$t('tables.listing.recurring_create_time'), key: "createTime", id: 2 },
        {
          label: this.$t('tables.listing.trackingNo'),
          key: "trackingNo",
          id: 3,
        },
        { label: this.$t('t.carrier'), key: "carrier", id: 4 },
        { label: this.$t('t.trackingStatus'), key: "trackingStatus", id: 5 },
        { label: this.$t('t.waybillStatus'), key: "reviewStatus", id: 6 },
        { label: this.$t('tables.listing.recurring_action'), key: "action", id: 7 },
      ]
    },
    waybillStatus () {
      return [
        { value: '', label: this.$t('statusLabel.allWaybillStatus') },
        { value: '2000', label: this.$t('statusLabel.pass') },
        { value: '1200', label: this.$t('statusLabel.processing') },
        { value: '1100', label: this.$t('statusLabel.return') },
        { value: '1000', label: this.$t('statusLabel.noUpload') },
      ]
    },
  },
  created() {
    // this.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half");
    this.locationHost = location.host;
    this.fetchCarrier();
  },
  async mounted() {
    // await this.initDropdown();
    // window.addEventListener("keyup", this.queryOrder, false);
    const that = this;
    that.$refs.uploadWayBill.ok = () => {
      if (that.currentItem.review_status != 1000 && that.currentItem.review_status != 1100) {
        that.$refs.uploadWayBill.close();
        return;
      }
      that.$validator.validateAll(that.uploadWayBill).then((result) => {
        if (that.checkUploadWayBill() && result) {
          that.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half");
          let params = {
            trade_no: that.uploadWayBill.trade_no,
            tracking_number: that.uploadWayBill.trackingNo,
            tracking_website: that.uploadWayBill.trackingWebsite,
            carrier_code: that.uploadWayBill.detailCarrier.code,
            merchant_note: that.uploadWayBill.notes,
          }
          let token = localStorage.getItem("Authorization");
          request({
            method: "post",
            url: `api/dashboard/waybill/update-tracking-by-trade?access_token=${token}`,
            data: params,
          })
            .then((res) => {
              if (res && res.data && res.data.code == 10000) {
                setTimeout(() => {
                  that.searching.close();
                  that.$refs.uploadWayBill.close()
                  that.$validator.reset()
                  that.searchWaybill()
                }, 800);
              } else {
                setTimeout(() => {
                  that.searching.close();
                }, 200);
                return;
              }
            })
            .catch((err) => {
              that.searching.close();
            });
        }
      })
    }
    that.$refs.uploadWayBill.cancel = () => {
      that.uploadWayBill.trade_no = "";
      that.uploadWayBill.merchantReference = "";
      that.uploadWayBill.notice = "";
      that.uploadWayBill.detailCarrier = "";
      that.uploadWayBill.carrierCountry = {id: "all-carrier-countries", value: "All Carrier Countries"};
      that.uploadWayBill.trackingNo = "";
      that.uploadWayBill.notes = "";
      that.$refs.uploadWayBill.close();
    }
    // 初始化查询
    // that.searchWaybill();
  },
  methods: {
    batchUpload() {
      this.$router.push({name: 'BatchUpload'})
    },
    downloadLogs() {
      this.$router.push({name: 'DownloadLog'})
    },
    download() {
      this.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half");
      let token = localStorage.getItem("Authorization");
      let params = {};
      const paramArray = ['review_status', 'carrier_code', 'tracking_status', 'search_mode', 'search_key', 'date_mode', 'zone_id', 'page_num', 'page_size']; // app_id: '',
      paramArray.forEach(m=> {
        if (this.waybillListParams[m]) {
          params[m] = this.waybillListParams[m];
        }
      })
      params.search_key = this.waybillListParams.search_key
      if (this.waybillListParams.time) {
        params.start_time = this.waybillListParams.time[0]
        params.end_time = this.waybillListParams.time[1]
      }
      this.waybillListParams.page_num = this.page
      this.waybillListParams.page_size = this.limit
      let that = this;
      request({
        method: "post",
        url: `api/dashboard/waybill/download?access_token=${token}`,
        data: params,
      })
        .then((res) => {
          if (res && res.data && res.data.code == 10000) {
            setTimeout(() => {
              that.showToast("Success", {
                icon: that.toastIcon,
                position: that.toastPosition,
                duration: that.toastDuration,
                fullWidth: that.isToastFullWidth,
              });
            }, 400);
            setTimeout(() => {
              that.searching.close();
              that.$router.push({
                path: "downloadLog",
              });
            }, 1500);
          } else {
            setTimeout(() => {
              that.searching.close();
            }, 200);
            return;
          }
        })
        .catch((err) => {
          that.searching.close();
        });
    },
    /**
     * review_status 提交过的都是大于1000的;退回是1100
     */
    singleUpload(data) {
      // console.log(this.carriersRegion, "this.carriersRegion")
      // console.log(this.filterDetailCarriers, "this.filterDetailCarriers")
      this.$validator.reset()
      this.filterDetailCarriers = this.carriers
      this.isNotice = data.review_status > 1000 ? true : false;
      this.isEdit = data.review_status == 1000 || data.review_status == 1100 ? false : true;
      if (!this.isEdit) {
        this.$refs.uploadWayBill.open()
        document.getElementsByClassName('modal-footer')[0].style = 'display:block;text-align:center';
        document.getElementsByClassName('modal-footer')[1].style = 'display:block;text-align:center';
      } else {
        this.$refs.uploadWayBillView.open()
        document.getElementsByClassName('modal-footer')[0].style = 'display:block;text-align:center';
        document.getElementsByClassName('modal-footer')[1].style = 'display:none;text-align:center';
      }
      // if (data.review_status <= 1100) {
      //   this.$refs.carrierCountryInput.$el.getElementsByTagName('input')[0].removeAttribute("disabled");
      //   this.$refs.carrierInput.$el.getElementsByTagName('input')[0].removeAttribute("disabled");
      // }
      this.currentItem = data;
      if (this.currentItem.detail) {
        this.currentItem.detail.from_detail.length > 0 && this.currentItem.detail.from_detail.forEach(value=>{
          this.fromDetail += value + "\n"
        })
        this.currentItem.detail.to_detail.length > 0 && this.currentItem.detail.to_detail.forEach(value=>{
          this.toDetail += value + "\n"
        })
      }
      this.uploadWayBill.carrierCountry = {id: "all-carrier-countries", value: "All Carrier Countries"};
      let renderObject = {
        trade_no: 'trade_no',
        merchantReference: 'out_trade_no',
        notice: `${envName}_notice`,
        trackingWebsite: 'tracking_website',
        trackingNo: 'tracking_number',
        notes: 'merchant_note',
      }
      // 先清空 在赋值
      Object.keys(renderObject).forEach((key) => {
          this.uploadWayBill[key] = ""
          this.uploadWayBill['detailCarrier'] = ""
      })
      Object.keys(renderObject).forEach((key) => {
        if (data[renderObject[key]]) {
          this.uploadWayBill[key] = data[renderObject[key]];
        }
      })
      if (data['carrier_code']) {
        this.uploadWayBill['detailCarrier'] = this.carriers.filter((carrier) => carrier.code == data['carrier_code'])[0]
        if (!this.uploadWayBill['detailCarrier'] || this.uploadWayBill['detailCarrier'].length === 0) {
          this.uploadWayBill['detailCarrier'] = {}
          this.uploadWayBill['detailCarrier'].code = this.currentItem.carrier_code
        }
      }

    },
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid =
          this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    searchWaybill() {
      this.page = 1;
      this.waybillData();
    },
    searchReset() {
        this.waybillListParams.time = [];
        this.waybillListParams.search_mode = '1';
        this.waybillListParams.search_key = '';
        this.waybillListParams.page_num = 1;
        this.waybillListParams.page_size = 10;
        this.waybillListParams.carrier_code = '';
        this.waybillListParams.tracking_status = '';
        this.waybillListParams.app_id = '';
        this.waybillListParams.date_mode = '';
        this.waybillListParams.zone_id = '';
        this.waybillListParams.review_status = '';
        this.page = 1;
        this.limit = 10;
        this.waybillData()
    },
    waybillData() {
      const that = this
      this.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half")
      let token = localStorage.getItem("Authorization");
      let params = {};
      const paramArray = ['review_status', 'carrier_code', 'tracking_status', 'search_mode', 'search_key', 'date_mode', 'zone_id', 'page_num', 'page_size', 'app_id'];
      paramArray.forEach(m=> {
        if (this.waybillListParams[m]) {
          params[m] = this.waybillListParams[m];
        }
      })
      params.search_key = this.waybillListParams.search_key
      if (this.waybillListParams.time) {
        params.start_time = this.waybillListParams.time[0]
        params.end_time = this.waybillListParams.time[1]
      }
      params.page_num = this.page
      params.page_size = this.limit
      request({
        method: "post",
        url: `api/dashboard/waybill/list?access_token=${token}`,
        data: params,
      })
        .then((res) => {
          if (!res) {
            this.searching.close();
            return;
          }
          if (res.data.code == 20000) {
            this.wayBillList = null;
            this.total = 0;
            this.noData = this.$t("t.noData");
            setTimeout(() => {
              that.searching.close();
            }, 200);
            return;
          }
          if (res.data.code == 10000) {
            this.wayBillList = res.data.data.list;
            this.total = res.data.data.total;
            setTimeout(() => {
              that.searching.close();
            }, 800);
          }
        })
        .catch((err) => {
          this.searching.close();
        });
    },
    getStatusColor(status) {
      if (status == "Success") {
        return "success";
      }
      if (
        status == "Dispute" ||
        status == "Controlling" ||
        status == "Cancelled"
      ) {
        return "warning";
      }
      if (
        status == "Refused" ||
        status == "Refunded" ||
        status == "ChargeBack" ||
        status == "Fail" ||
        status == "PayFail"
      ) {
        return "danger";
      }
      return "info";
    },
    launchToast() {
      this.isToastContentPresent = true;
      this.showToast(this.toastText, {
        icon: this.toastIcon,
        position: this.toastPosition,
        duration: this.toastDuration,
        fullWidth: this.isToastFullWidth,
      });
      this.isToastContentPresent = false;
    },
    limitNextDay() {
      if (document.querySelector(".today")) {
        if (document.querySelector(".today").nextSibling.className) {
          document.querySelector(".today").nextSibling.className =
            "normal disabled";
        }
      }
      if (this.isMobile === "mobile") {
        let datePicker = document.querySelector(".el-date-range-picker");
        if (datePicker) {
          datePicker.style.width = "325px";
          datePicker.style.left = "40px";
          document.querySelector(
            ".el-date-range-picker .el-picker-panel__body"
          ).style.minWidth = "325px";
          document.querySelector(
            ".el-date-range-picker__content.is-left"
          ).style.width = "100%";
          document.querySelector(
            ".el-date-range-picker__content.is-right"
          ).style.width = "100%";
        }
      }
    },
    isCarrierVaild (field) {
      let isValid = false
      if (this.detailCarrierStatus) {
        isValid = true
      }
      return isValid
    },
    isCarrierCountryVaild (field) {
      let isValid = false
      if (this.carrierCountryStatus) {
        isValid = true
      }
      return isValid
    },
    // 检查 弹框 下拉状态
    checkUploadWayBill() {
      let that = this
      let wayBillArray = ['detailCarrier']
      let isValidate = wayBillArray.reduce((result, current) => {
        if (!that.uploadWayBill[current]) {
          that[current + 'Status'] = true
        } else {
          that[current + 'Status'] = false
        }
        return result && !that[current + 'Status']
      }, true)
      return isValidate
    },
    carrierForbiddenInput (val) {
      if (!val) {
        this.$refs.carrierInput.$el.getElementsByTagName('input')[0].style.height =
          '28px'
        this.detailCarrierStatus = true
      } else {
        this.detailCarrierStatus = false
      }
    },
    carrierCountryForbiddenInput (val) {
      if (!val) {
        this.carrierCountryStatus = true
      } else {
        this.carrierCountryStatus = false
        this.uploadWayBill.detailCarrier = "";
        if (val.value != "All Carrier Countries") {
          this.filterDetailCarriers = this.carriers.filter(carrier => carrier.region === val.value);
        } else {
          this.filterDetailCarriers = this.carriers;
        }
      }
    },
    fetchDetails(itemId) {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      localStorage.setItem("tid", itemId);
      this.getOrderInfoById(
        this.$route.params.tid || localStorage.getItem("tid")
      );
    },
    // 获取订单信息
    getOrderInfoById(tid) {
      let token = localStorage.getItem("Authorization");
      this.$set(this.depositUpload, "uploadUrl", "");
      request({
        method: "post",
        url: `api/dashboard/order/queryById?tid=${tid}&access_token=${token}`,
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          // 清空历史列表
          this.statusHistoryInfo.splice(0, this.statusHistoryInfo.length);
          if (res.status === 200) {
            let orderData = res.data;
            if (orderData.code === "10000") {
              this.dialogTableVisible = true;
              orderData = orderData.data;
              if (orderData.voucher) {
                this.$set(
                  this.depositUpload,
                  "uploadUrl",
                  orderData.voucher.uploadUrl
                );
                if (orderData.voucher.paymentVoucher) {
                  this.$set(this.payVouchers, 0, {
                    name: "Payment Voucher",
                    time: this.dateFormat(
                      orderData.voucher.paymentVoucher.time * 1000
                    ),
                    url: orderData.voucher.paymentVoucher.url,
                  });
                } else {
                  this.$set(this.payVouchers, 0, {
                    name: "Payment Voucher",
                    time: "N/A",
                    url: "",
                  });
                }

                if (orderData.voucher.personalId) {
                  this.$set(this.payVouchers, 1, {
                    name: "Personal I.D.",
                    time: this.dateFormat(
                      orderData.voucher.personalId.time * 1000
                    ),
                    url: orderData.voucher.personalId.url,
                  });
                } else {
                  this.$set(this.payVouchers, 1, {
                    name: "Personal I.D.",
                    time: "N/A",
                    url: "",
                  });
                }

                if (orderData.voucher.addrProof) {
                  this.$set(this.payVouchers, 2, {
                    name: "Proof of Address",
                    time: this.dateFormat(
                      orderData.voucher.addrProof.time * 1000
                    ),
                    url: orderData.voucher.addrProof.url,
                  });
                } else {
                  this.$set(this.payVouchers, 2, {
                    name: "Proof of Address",
                    time: "N/A",
                    url: "",
                  });
                }
              }
              this.detailInfo[0][0] = orderData.detail.trade_no
                ? orderData.detail.trade_no
                : "N/A";
              this.detailInfo[0][1] =
                orderData.detail.trans_base.order_currency &&
                orderData.detail.trans_base.order_amount
                  ? `${orderData.detail.trans_base.order_currency} ${orderData.detail.trans_base.order_amount}`
                  : "N/A";
              this.detailInfo[0][2] = orderData.detail.trans_base.subject
                ? orderData.detail.trans_base.subject
                : "N/A";
              this.detailInfo[0][3] = orderData.detail.trans_base.method
                ? orderData.detail.trans_base.method
                : "N/A";
              this.checkCanRefund();
              this.detailInfo[0][4] = orderData.detail.trans_base.trade_status
                ? orderData.detail.trans_base.trade_status
                : "N/A";
              this.detailInfo[0][5] = orderData.detail.trans_base.create_time
                ? this.dateFormat(orderData.detail.trans_base.create_time)
                : "N/A";
              // this.detailInfo[0][6] = orderData.trans_logs[0].log_callback_status + ' Callback' // 后台暂时没有
              this.out_trade_no = orderData.detail.out_trade_no
              this.app_id = orderData.detail.trans_base.app_id
              this.speiFlag = orderData.detail.trans_base.method == "SPEI" ? true : false;
              this.detailMethod = [
                "CreditCard",
                "Boleto",
                "Lottery",
                "DepositExpress",
                "PIX",
                "Pix",
                "Wallet",
                "SPEI",
              ].includes(orderData.detail.trans_base.method);
              this.detailInfo[1] =
                this.detailMethod === true &&
                (orderData.detail.trans_base.trade_status === "Success" ||
                  orderData.detail.trans_base.trade_status === "PartialRefund")
                  ? ["Refund"]
                  : [""];
              this.detailInfo[1][1] = "Callback"
              this.detailInfo[1][2] = "Match Status"
              for (let i = 0; i < orderData.detail.trans_logs.length; i++) {
                let statusHistory = [];
                var refundMoney = orderData.detail.trans_logs[i].amount
                  ? orderData.detail.trans_logs[i].currency +
                    " " +
                    orderData.detail.trans_logs[i].amount
                  : orderData.detail.trans_base.order_amount
                  ? orderData.detail.trans_base.order_currency +
                    " " +
                    orderData.detail.trans_base.order_amount
                  : "N/A";
                statusHistory.push(
                  orderData.detail.trans_logs[i].log_status
                    ? orderData.detail.trans_logs[i].log_status
                    : "N/A"
                );
                statusHistory.push(
                  orderData.detail.trans_logs[i].create_time
                    ? this.dateFormat(
                        orderData.detail.trans_logs[i].create_time
                      )
                    : "N/A"
                );
                statusHistory.push(refundMoney);
                statusHistory.push(
                  orderData.detail.trans_logs[i].log_callback_status
                    ? orderData.detail.trans_logs[i].log_callback_status
                    : "N/A"
                );
                this.$set(this.statusHistoryInfo, i, statusHistory);
              }
              this.merchantInfo = {
                "App Name": orderData.detail.trans_base.app_name,
                "App ID": orderData.detail.trans_base.app_id,
                "Merchant Reference": orderData.detail.out_trade_no,
              };
              // this.refundAmount = orderData.detail.trans_base.order_amount;
              this.refundAmount = orderData.refundable_amount;
              this.successfulEmail = orderData.detail.trans_base.user_info
                ? orderData.detail.trans_base.user_info.email
                : "N/A"; // 用户的邮箱
              this.refundExplain = this.detailInfo[0][2]; // 拒绝的描述
              // 设置交易信息
              this.transactionInfo = [];
              if (orderData.detail.trans_base) {
                if (orderData.detail.trans_base.processing_fee_detail) {
                  let processing_fee_detail = JSON.parse(
                    orderData.detail.trans_base.processing_fee_detail
                  );
                  this.transactionInfo.push(processing_fee_detail.feeName);
                  this.transactionInfo.push(processing_fee_detail.ext);
                  this.transactionInfo.push(processing_fee_detail.feeAmount);
                }
              }
              // 设置购买用户的信息
              this.buyerInfo = [];
              if (orderData.detail.trans_base) {
                if (orderData.detail.trans_base.payment_info) {
                  var amountMoney = "N/A";
                  var amountCurrency = "";
                  var payAmount = {
                    type: "",
                    number: "",
                  };
                  var payIdentify =
                    orderData.detail.trans_base.payment_info.identify;
                  if (payIdentify) {
                    if (typeof payIdentify === "string") {
                      amountCurrency =
                        orderData.detail.trans_base.payment_info.currency;
                      if (payIdentify.length <= 12) {
                        payAmount = {
                          type: "cpf",
                          number: payIdentify,
                        };
                      } else if (payIdentify.length > 13) {
                        payAmount = {
                          type: "cnpj",
                          number: payIdentify,
                        };
                      }
                    } else if (
                      Object.prototype.toString.call(payIdentify) ===
                      "[object Object]"
                    ) {
                      payAmount = {
                        type: payIdentify.type,
                        number: payIdentify.number,
                      };
                    }
                  }
                  this.buyerInfo.push({
                    NAME:
                      orderData.detail.trans_base.payment_info.buyer_name ||
                      "N/A",
                    "CPF/CNPJ": payIdentify
                      ? formatUserCredentials(payAmount.type, payAmount.number)
                      : "N/A",
                  });
                  this.buyerInfo.push({
                    MUID:
                      (orderData.detail.trans_base.user_info
                        ? orderData.detail.trans_base.user_info.buyer_id
                        : "N/A") || "N/A",
                    Email:
                      orderData.detail.trans_base.payment_info.email || "N/A",
                  });
                  this.buyerInfo.push({
                    "Phone Number":
                      orderData.detail.trans_base.payment_info.phone || "N/A",
                  });
                } else {
                  this.buyerInfo.push({
                    NAME: "N/A",
                    "CPF/CNPJ": "N/A",
                  });
                  this.buyerInfo.push({
                    MUID:
                      (orderData.detail.trans_base.user_info
                        ? orderData.detail.trans_base.user_info.buyer_id
                        : "N/A") || "N/A",
                    Email: "N/A",
                  });
                  this.buyerInfo.push({ "Phone Number": "N/A" });
                }
                if (orderData.detail) {
                  if (orderData.detail.trans_logs) {
                    if (
                      orderData.detail.trans_logs[0].log_status === "Refused"
                    ) {
                      this.refusedFg = true;
                      if (orderData.risk) {
                        this.refusedInfo = orderData.risk.refuseInfo || "N/A";
                      } else {
                        this.refusedInfo = "N/A";
                      }
                    }
                  }
                }
              }
              // 隐藏loading
              setTimeout(() => {
                this.loading.close();
              }, 200);
            } else {
              // 隐藏loading
              setTimeout(() => {
                this.loading.close();
              }, 200);
              this.$message({
                message: "System error, please refresh and try again!",
                type: "warning",
              });
            }
          }
        })
        .catch((err) => {
          // 隐藏loading
          setTimeout(() => {
            this.loading.close();
          }, 200);
          console.log(err);
        });
    },
    // **********主要方法************
    // 获取carrier的list 快递公司
    fetchCarrier() {
      let that = this;
      let token = localStorage.getItem("Authorization");
      request({
        method: "post",
        url: `api/dashboard/basic/getDropdown?access_token=${token}`,
        // url: `api/admin/common/options?access_token=${token}`,
        data: {},
      })
        .then((res) => {
          if (!res) {
            // that.searching.close();
            return;
          }
          setTimeout(() => {
            // that.searching.close();
          }, 200);
          that.carriers = res.data.carriers;
          that.carriers.forEach((carrier) => {
            if (!carrier.region) {
              carrier.region = "Global";
            }
            if (that.carriersRegion.findIndex(region => carrier.region === region.value) === -1) {
              that.carriersRegion.push(
                {id: carrier.code, value: carrier.region}
              );
            }
          })
          that.filterCarriers = that.carriers;
          // app
          that.appList = [{ id: "", name: "All" }].concat(res.data.apps);
          that.waybillListParams.app_id = this.appList[0].id;
        })
        .catch((err) => {
          // that.searching.close();
        });
    },
    carrierRegionChange(value) {
      this.waybillListParams.carrier_code = "";
      if (value != "All Carrier Countries") {
        this.filterCarriers = this.carriers.filter(carrier => carrier.region === value);
      } else {
        this.filterCarriers = this.carriers;
      }
    },
    loadingFullScreen(controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    carrierClose () {
      this.uploadWayBill.carrierCountry = {id: "all-carrier-countries", value: "All Carrier Countries"};
    },
    dateModeChange(value) {
      if (value === "") {
        this.isTimeZoned = true;
        this.waybillListParams.zone_id = "";
        this.waybillListParams.time = [];
      } else {
        this.isTimeZoned = false;
        this.waybillListParams.zone_id = "Etc/GMT+3";
        this.waybillListParams.time = [];
        this.waybillListParams.time.push(
          moment().subtract(31, "days").format("YYYY-MM-DD 00:00:00")
        );
        this.waybillListParams.time.push(moment().format("YYYY-MM-DD 23:59:59"));
      }
    },
    // 商户后台除了1000是No Upload，1100是Return，>=2000是Pass，其余都是Processing应该，你可以前端cover一下，我后台返回数据应该也要格式化一下
    reviewStatusText(status) {
      let currentStatus = '';
      // switch (status) {
      //   case 1000:
      //     currentStatus = 'Pending';
      //     break;
      //   case 1100:
      //     currentStatus = 'Return';
      //     break;
      //   case 1200:
      //     currentStatus = 'Waiting';
      //     break;
      //   case 1500:
      //     currentStatus = 'Processing';
      //     break;
      //   case 2000:
      //     currentStatus = 'Pass';
      //     break;
      //   default:
      //     currentStatus = '';
      //     break;
      // }
      if (status === 1000) {
        currentStatus = this.$t('statusLabel.noUpload')
      } else if (status === 1100) {
        currentStatus = this.$t('statusLabel.return')
      } else if (status >= 2000) {
        currentStatus = this.$t('statusLabel.pass')
      } else {
        currentStatus = this.$t('statusLabel.processing')
      }
      return currentStatus;
    },
    handleModalClose() {
      this.clabe = ""
      this.bankCode = ""
    },
    selectBankCode(id) {
      this.selectedBank = this.bankCodeList.find((item) => {
        return item.value === id
      })
    },
    fillOrderModalClose() {
      this.fillStatus = ""
      this.userPass = ""
    },
    selectStatusCode(id) {
      this.selectedStatus = this.statusOptions.find((item) => {
        return item.value === id
      })
    },
    formatCardNumber(e) {
      // 格式化银行卡号
      if (e.target.value.length === 4) {
        e.target.value += " ";
      }
      if (e.target.value.length === 9) {
        e.target.value += " ";
      }
      if (e.target.value.length > 14) {
        e.target.value = e.target.value.substring(0, 14);
      }
    },
    forbiddenInput(val) {
      if (!val) {
        this.$refs.bankInput.$el.getElementsByTagName("input")[0].style.height =
          "28px";
        this.bankStatus = true;
      } else {
        this.bankStatus = false;
      }
    },
    forbiddenAccountInput(val) {
      if (!val) {
        this.$refs.accountInput.$el.getElementsByTagName(
          "input"
        )[0].style.height = "28px";
        this.bankStatus = true;
      } else {
        this.bankStatus = false;
      }
    },
    // 设置buyer移动端的宽度
    hideBuyerTd(item) {
      if (item === "MUID") {
        return true;
      } else {
        return true;
      }
    },
    //  增加详情页面
    getVerticalTabTd(key, item, str, noId, i) {
      if (str === "device") {
        return `<b class="${this.verticalTitle} device">${this.translateDetailLabel(key)}</b>${item}`;
      } else if (str === "buyer") {
        let mywidth = noId % 2 === 1 ? "120px" : "80px";
        // if(item === 'MUID') {
        //   return;
        // }
        return `<b class="${this.verticalTitle} buyer" style="width:${mywidth}">${this.translateDetailLabel(item)}</b> ${key}`;
      } else if (str === "merchant") {
        return `<b class="${this.verticalTitle} merchant">${this.translateDetailLabel(key)}</b> ${item}`;
      } else if (!str) {
        return `<b class="${this.verticalTitle} mgr">${this.translateDetailLabel(item)}</b> ${key}`;
      }
    },
    translateDetailLabel(label) {
      return mapDetailLabel(this, label);
    },
    // 检查当前的现金支付是否可以退款
    checkCanRefund() {
      var refundChannels = [
        "Boleto",
        "Lottery",
        "DepositExpress",
        "PIX",
        "Pix",
        "SPEI",
      ];
      if (refundChannels.includes(this.detailInfo[0][3])) {
        if (this.speiFlag) {
          this.dispalyOtherFg = false;
          return true;
        } else {
          // this.checkboxOption = true;
          // this.dispalyOtherFg = true;
          return true;
        }
      }
      return false;
    },
    showMediumModal() {
      // this.refundMount = this.successfulEmail = this.refundExplain = this.single = this.userPass = ''
      this.single =
      this.userPass =
      this.username =
      this.cpfNO =
      this.agency =
      this.selBank =
      this.accountType =
      this.bankAccountNumberFirst =
      this.bankAccountNumberLast =
      this.clabe =
      this.bankCode =
        "";
      this.selectedBank = {};
      if (
        this.detailInfo[0][3] === "CreditCard" ||
        this.detailInfo[0][3] === "Wallet"
      ) {
        this.checkboxOption = false;
        this.$refs.mediumModal.open();
        this.$refs.mediumModal.style = "";
        // 限制拒绝退款的调用频率
        var callFrequency2Refund = {
          orderId: this.detailInfo[0][0],
          dataTime: new Date().getTime(), //  每1分钟才能重发
          countCk: 0,
        };
        this.$refs.mediumModal.ok = (callFrequency2Refund) => {
          this.toSubmitRefundData(callFrequency2Refund);
        };
      } else if (this.checkCanRefund()) {
        // TODO
        this.$refs.mediumModal.open();
        this.$refs.mediumModal.style = "";
        // 限制拒绝退款的调用频率
        var callFrequency2Refund = {
          orderId: this.detailInfo[0][0],
          dataTime: new Date().getTime(), //  每1分钟才能重发
          countCk: 0,
        };
        this.$refs.mediumModal.ok = (callFrequency2Refund) => {
          this.toSubmitRefundData(callFrequency2Refund, this.checkboxOption);
        };
      } else {
        return;
      }
    },
    showModalFillOrder() {
      this.userPass = "";
      this.fillStatus = "";
      this.selectedStatus = {};
      if (
        this.detailInfo[1][2] === "Match Status"
      ) {
        this.$refs.fillOrderModal.open();
        this.$refs.fillOrderModal.style = "";
        // 限制拒绝退款的调用频率
        var requestFrequencyLimit = {
          orderId: this.detailInfo[0][0],
          dataTime: new Date().getTime(), //  每1分钟才能重发
          countCk: 0,
        };
        this.$refs.fillOrderModal.ok = (requestFrequencyLimit) => {
          this.commitFillOrderInfo(requestFrequencyLimit);
        };
      } else {
        return;
      }
    },
    commitFillOrderInfo(ckObj) {
      let trade_no = this.$route.params.tid || localStorage.getItem("tid");
      if (trade_no === ckObj.orderId && ckObj.countCk > 1) {
        return;
      }
      let token = localStorage.getItem("Authorization");
      const param = new FormData();
      param.append("app_id", this.app_id);
      param.append("out_trade_no", this.out_trade_no);
      param.append("trade_status", this.selectedStatus.value);
      param.append("password", this.userPass);

      this.$refs.fillOrderModal.close();
      request({
        method: "post",
        url: `api/dashboard/order/match-status?access_token=${token}`,
        // url: `api/dashboard/order/fill-order?access_token=${token}`,
        data: param,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        ckObj.countCk++
        let code = res.data.code
        this.show = false;
        if (code == 10000) {
          this.toastText = res.data.msg || 'Success!'
          this.dialogTableVisible = false;
          this.launchToast()
          setTimeout(function() {
            this.loadingFullScreen("loading", "Loading", "fa fa-hourglass-half")
            this.orderData()
          }, 20);
        } else {
          this.toastText = res.data.sub_msg || "Business Failed"
          this.launchToast()
        }
      }).catch(err => {
        this.toastText = err.msg || "Business Failed"
        this.launchToast()
      })
    },
    resizeLabel(e) {
      e.currentTarget.style.paddingTop = "5px";
    },
    focusLabel(e) {
      e.currentTarget.style.paddingTop = "18px";
    },
    // 退款confirm 点击事件
    toSubmitRefundData(callBkObj, others) {
      if (this.refundCanDo === false) {
        return;
      }
      if (!this.refundAmount) {
        return;
      }
      if (!this.successfulEmail) {
        return;
      }
      if (!this.refundExplain) {
        return;
      }
      if (!this.userPass) {
        return;
      }
      // 其他现金支付提交
      if (others) {
        if (this.dispalyOtherFg) {
          if (!this.username) {
            return;
          }
          if (!this.cpfNO) {
            return;
          }
          if (!this.agency) {
            return;
          }
          if (!this.selBank) {
            return;
          }
          if (!this.accountType) {
            return;
          }
          if (!this.bankAccountNumberFirst) {
            return;
          }
          if (!this.bankAccountNumberLast) {
            return;
          }
        } else {
            this.username =
            this.cpfNO =
            this.agency =
            this.selBank =
            this.accountType =
            this.bankAccountNumberFirst =
            this.bankAccountNumberLast =
              "";
        }
      } else {
        if (this.speiFlag) {
          if (!this.bankCode) {
            return;
          }
          if (!this.clabe) {
            return;
          }
        }
      }
      this.commitRefundInfo(callBkObj);
    },
        downloadAttachment(obj, e) {
      // 跨域问题，不能直接下载
      // downloadImage(obj.url, obj.name.replace(" ", "_") + '_' + Math.floor((Math.random()*10000000)+1));
      if (event) {
        event.preventDefault();
      }
      let routes = this.$router.resolve({ name: "downloadDoc" });
      window.open(routes.href + "?downLoadUrl=" + obj.url, "_blank");
    },

    isBankVaild(field) {
      let isValid = false;
      if (this.bankStatus) {
        isValid = true;
      }
      return isValid;
    },
    isAccountVaild(field) {
      let isValid = false;
      if (this.aTypeStatus) {
        isValid = true;
      }
      return isValid;
    },
    initRefund() {
      this.refundAmount = "";
      this.successfulEmail = "";
      this.refundExplain = "";
      this.loading.close();
    },
    // 提交退款相关的信息
    commitRefundInfo(ckObj) {
      let trade_no = this.$route.params.tid || localStorage.getItem("tid");
      if (trade_no === ckObj.orderId && ckObj.countCk > 1) {
        this.refundCanDo = false;
        return;
      }
      let token = localStorage.getItem("Authorization");
      const param = new FormData();
      param.append("trade_no", trade_no);
      param.append("amount", this.refundAmount);
      param.append("email", this.successfulEmail);
      param.append("desc", this.refundExplain);
      // param.append("clabe", this.clabe);
      // param.append("bank_code", this.bankCode);
      param.append("password", this.userPass);
      if (this.dispalyOtherFg) {
        param.append("identify", this.cpfNO.replace(".", "").replace("-", ""));
        param.append("username", this.username);
        let bankInfo = {
          bank_id: this.selBank.value,
          bank_name: this.selBank.description,
          agency: this.agency,
          type: "" + this.accountType.id,
          number:
            this.bankAccountNumberFirst.replace(/\s/g, "") +
            "-" +
            this.bankAccountNumberLast,
        };
        param.append("bank_info", JSON.stringify(bankInfo));
      }
      if (this.speiFlag) {
        let bankInfo = {
          bank_id: this.selectedBank.value,
          bank_name: this.selectedBank.label,
          number: this.clabe,
        }
        param.append("bank_info", JSON.stringify(bankInfo));
      }
      // 调试银行的信息 TODO
      // if (this.single.length === 1) {
      //   param.append('file', this.single[0])
      // }
      this.$refs.mediumModal.close();
      request({
        method: "post",
        url: `api/dashboard/order/refund?access_token=${token}`,
        data: param,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        ckObj.countCk++
        let code = res.data.code
        this.show = false;
        if (code == 10000) {
          this.toastText = res.data.msg || 'Success!'
          this.dialogTableVisible = false;
          this.launchToast()
          setTimeout(function() {
            this.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half")
            this.searchWaybill()
          }, 20);
        } else {
          this.toastText = res.data.sub_msg
          this.launchToast()
        }
      }).catch(err => {
        this.toastText = err.msg || "Business Failed"
        this.launchToast()
      });
    },

    callbackOrderStatus () {
      this.isLoading = true
      let token = localStorage.getItem('Authorization')
      let out_trade_no = this.out_trade_no
      let app_id = this.app_id
      request({
        method: 'post',
        url: `api/dashboard/order/callback?access_token=${token}&app_id=${app_id}&out_trade_no=${out_trade_no}`,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        let code = res.data.code
        if (code == 10000) {
          this.toastText = res.data.msg || 'Success!'
          this.launchToast()
          setTimeout(() => {
            this.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half")
            this.searchWaybill()
          }, 20);
        } else {
          this.toastText = res.data.msg
          this.launchToast()
        }
        this.isLoading = false
      }).catch(err => {
        this.toastText = err.msg
        this.launchToast()
        this.isLoading = false
      })
    },
    dateFormat(value) {
      return moment
        .tz(moment.tz(value, "UTC"), this.currTimeZone)
        .format("YYYY-MM-DD HH:mm:ss");
    },


  },
};
</script>
<style>
@media only screen and (max-width: 750px) {
  .el-pagination.is-background {
    display: flex;
    flex-wrap: wrap;
    height: 70px;
  }
  .el-pagination__total {
    order: 1;
    margin-right: 20px !important;
    letter-spacing: 2px;
  }
  .btn-prev {
    width: 20px;
    order: 2;
    margin-right: 10px !important;
  }
  .el-pager {
    order: 4;
  }
  .btn-next {
    width: 20px;
    order: 3;
  }
}
</style>

<style lang="scss" scoped>
.vs__dropdown-toggle {
  border: none !important;
}
/deep/ .el-select-dropdown__item.selected{
  color: #4ae387 !important;
}
.el-select {
  display: block;
  position: relative;
}
/deep/ .iconicstroke-download {
  display: inline-block;
  margin-left: 60px;
  height: 30px;
  line-height: 30px;
  font-size: 24px;
}
.select-title {
  color: $VUE_APP_COLOR3;
}
.table th {
  text-align: center;
}
.table td {
  text-align: center;
}
.alink {
  color: $vue-green;
  text-decoration: underline;
}

/*  增加详情页面 */
table {
  text-align: center;
}
.vuestic-breadcrumbs__help-section {
  display: none;
}
.span-wrapper {
  display: inline-block;
  height: 37px;
  line-height: 37px;
}
/deep/ .vertical-title {
  font-size: 16px;
  font-weight: 700;
  display: inline-block;
  width: 140px;
  height: 37px;
  line-height: 37px;
  text-align: right;
  padding-right: 15px;
}
/deep/ .device {
  width: 90px;
  margin-right: 100px;
}

/deep/ .btn-micro {
  letter-spacing: 1px;
  .btn-with-icon-content {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    max-width: 160px;
    .ion {
      width: 22px;
    }
    b {
      font-weight: 400;
    }
  }
}

#merchant {
  // height: 228px;
  .table td {
    text-align: left;
  }
}
#waybillTable .table thead th {
  width: 300px;
}
.first-td-padding td:first-child {
  padding-left: 0.5rem !important;
}
#details .table-striped tbody tr:nth-of-type(even) {
  background-color: #ffffff;
}
#refundReason .vuestic-modal .modal-header {
  .modal-title {
    margin-bottom: 0;
    line-height: 1.5;
    flex: 1;
    display: flex;
    justify-content: center;
  }
}
#refundReason .vuestic-widget .vuestic-widget-header {
  padding-left: 10px;
}
#refundReason .form-group {
  #fileUploadWrapper .control-label {
    position: relative;
  }
  #fileUploadWrapper.flex {
    padding: 0;
  }
  #textareawrapper.flex {
    padding: 0;
  }
  #uploadFile {
    height: calc(100% - 30px);
  }
}
/deep/ #refundReason {
  .vuestic-modal .modal {
    display: flex;
    align-items: center;
  }
}

/deep/ .vuestic-scrollbar {
  .scrollbar-wrapper {
    padding-top: 14px;
    max-height: 600px;
  }
}
/deep/ .buyer {
  width: 120px !important;
}
/deep/ .merchant {
  width: 150px;
  margin-right: 100px;
}
/deep/ .el-dialog {
  margin-top: 0.2vh !important;
  width: 98%;
}
/deep/ .el-dialog__header {
  padding: 10px 10px 0 !important;
}
/deep/ .el-dialog__headerbtn {
  position: absolute;
  top: 0;
  right: 5px;
  font-size: 30px;
}
/deep/ .el-dialog__title {
  font-size: 1.375rem;
  font-weight: 600;
}
/deep/ .el-dialog__body {
  padding: 10px 0 !important;
}
#paymentDetails .vuestic-widget {
  margin-bottom: 10px !important;
}
.btn.btn-primary.pull-right {
  background-color: rgb(26, 188, 156);
  border-color: rgb(22, 160, 133);
  color: #c8f9c5;
  &:visited {
    background-color: rgb(26, 188, 156);
    border-color: rgb(22, 160, 133);
  }
  &:active {
    background-color: rgb(26, 188, 156);
    border-color: rgb(22, 160, 133);
    color: #fff;
  }
  &:hover {
    background-color: rgb(26, 188, 156);
    border-color: rgb(22, 160, 133);
    color: #fff;
  }
  &:focus {
    background-color: rgb(26, 188, 156);
    border-color: rgb(22, 160, 133);
  }
}
/deep/ .btn.btn-danger[disabled] {
  background: gray;
  color: #e4e7ed;
  cursor: default;
}
.oneline-voucher {
  display: flex;
  width: 100%;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.vuestic-icon-dollar:before {
  font: normal normal normal 14px/1 FontAwesome;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  width: 14px;
  text-align: center;
  content: "\F155";
}
/deep/ #refundReason .modal-body {
  max-height: 70vh;
  overflow-y: auto;
}

/deep/ #refundReason .modal-dialog {
  width: 50vw;
}

/deep/ #refundReason #bankWrapper .vuestic-scrollbar .scrollbar-wrapper {
  margin-bottom: 10px !important;
}

/deep/ #refundReason #bankWrapper .dropdown-menu .dropdown-menu-content {
  padding-bottom: 20px !important;
}

@media only screen and (max-width: 960px) {
  /deep/ .merchant {
    margin-right: 30px;
  }
}
@media only screen and (max-width: 750px) {
  .mobile-btn {
    padding: 0.5rem 0.2rem 0;
  }
  /deep/ #dategridPayOrder.vuestic-widget {
    .vuestic-widget-body {
      padding: 0;
    }
  }
  /deep/ .pagination-container {
    padding: 5px 4px 10px;
    .el-pagination__total {
      display: block;
      margin-right: 4px;
    }
    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      margin: 0 2px 0;
    }
  }

  /deep/ .pagination-container {
    padding: 5px 4px 10px;
    .el-pagination {
      padding: 0;
    }
    .el-pagination__total {
      display: block;
      margin-right: 4px;
    }
    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      margin: 0 1px 0;
    }
  }

  /deep/ .buyer {
    padding-left: 5px;
    width: auto !important;
  }

  #paymentDetails {
    /deep/ .el-dialog {
      overflow: hidden;
      .vuestic-widget .vuestic-widget-body {
        overflow-x: auto;
        padding: 0.2rem;
      }
    }
  }
  #details {
    min-width: 600px;
  }
  /deep/ .merchant {
    margin-right: 20px;
  }
}

/deep/ .info-group {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
  align-self: auto;
  margin-bottom: 2rem;
  .with-icon-right {
    width: 100%;
  }
  .info-group-space {
    width: 4rem;
  }
  // .input-group {
  //   align-self:auto
  // }
  .form-group {
    margin-bottom: 0;
  }
}
/deep/ .scrollbar-wrapper {
  max-height: 200px !important;
  // overflow-y: scroll;
}
.info-disabled {
  .control-label {
    font-size: 0.6rem;
    color: #4ae387;
    font-weight: 600;
    text-transform: uppercase;
    top: -0.6rem;
    left: 0;
  }
  .vuestic-simple-select__unselect {
    display: none;
  }
}
/deep/ .el-pagination {
  text-align: center;
}
</style>
